//@ts-nocheck
  // DO NOT MODIFY THIS FILE. This file is automatically generated by Tina
  export function gql(strings: TemplateStringsArray, ...args: string[]): string {
    let str = ''
    strings.forEach((string, i) => {
      str += string + (args[i] || '')
    })
    return str
  }
  export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** References another document, used as a foreign key */
  Reference: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type SystemInfo = {
  __typename?: 'SystemInfo';
  filename: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  basename: Scalars['String']['output'];
  breadcrumbs: Array<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  relativePath: Scalars['String']['output'];
  extension: Scalars['String']['output'];
  template: Scalars['String']['output'];
  collection: Collection;
};


export type SystemInfoBreadcrumbsArgs = {
  excludeExtension?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Folder = {
  __typename?: 'Folder';
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  hasPreviousPage: Scalars['Boolean']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  startCursor: Scalars['String']['output'];
  endCursor: Scalars['String']['output'];
};

export type Node = {
  id: Scalars['ID']['output'];
};

export type Document = {
  id: Scalars['ID']['output'];
  _sys?: Maybe<SystemInfo>;
  _values: Scalars['JSON']['output'];
};

/** A relay-compliant pagination connection */
export type Connection = {
  totalCount: Scalars['Float']['output'];
  pageInfo: PageInfo;
};

export type Query = {
  __typename?: 'Query';
  getOptimizedQuery?: Maybe<Scalars['String']['output']>;
  collection: Collection;
  collections: Array<Collection>;
  node: Node;
  document: DocumentNode;
  page: Page;
  pageConnection: PageConnection;
  menu: Menu;
  menuConnection: MenuConnection;
  tag: Tag;
  tagConnection: TagConnection;
  settings: Settings;
  settingsConnection: SettingsConnection;
};


export type QueryGetOptimizedQueryArgs = {
  queryString: Scalars['String']['input'];
};


export type QueryCollectionArgs = {
  collection?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNodeArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDocumentArgs = {
  collection?: InputMaybe<Scalars['String']['input']>;
  relativePath?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPageArgs = {
  relativePath?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPageConnectionArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PageFilter>;
};


export type QueryMenuArgs = {
  relativePath?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMenuConnectionArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<MenuFilter>;
};


export type QueryTagArgs = {
  relativePath?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTagConnectionArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TagFilter>;
};


export type QuerySettingsArgs = {
  relativePath?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySettingsConnectionArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SettingsFilter>;
};

export type DocumentFilter = {
  page?: InputMaybe<PageFilter>;
  menu?: InputMaybe<MenuFilter>;
  tag?: InputMaybe<TagFilter>;
  settings?: InputMaybe<SettingsFilter>;
};

export type DocumentConnectionEdges = {
  __typename?: 'DocumentConnectionEdges';
  cursor: Scalars['String']['output'];
  node?: Maybe<DocumentNode>;
};

export type DocumentConnection = Connection & {
  __typename?: 'DocumentConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
  edges?: Maybe<Array<Maybe<DocumentConnectionEdges>>>;
};

export type Collection = {
  __typename?: 'Collection';
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  format?: Maybe<Scalars['String']['output']>;
  matches?: Maybe<Scalars['String']['output']>;
  templates?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  fields?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  documents: DocumentConnection;
};


export type CollectionDocumentsArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DocumentFilter>;
  folder?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentNode = Page | Menu | Tag | SettingsGeneralSettings | SettingsSocialNetworkSettings | SettingsTrackingSettings | SettingsContactSettings | SettingsProjectSettings | Folder;

export type PageParentPage = Page;

export type PageContentWidgetBannerImage = {
  __typename?: 'PageContentWidgetBannerImage';
  image?: Maybe<Scalars['String']['output']>;
  alt?: Maybe<Scalars['String']['output']>;
  credits?: Maybe<Scalars['String']['output']>;
  aspectRatio?: Maybe<Scalars['String']['output']>;
};

export type PageContentWidgetHeadingImageNode = {
  __typename?: 'PageContentWidgetHeadingImageNode';
  image?: Maybe<Scalars['String']['output']>;
  alt?: Maybe<Scalars['String']['output']>;
  credits?: Maybe<Scalars['String']['output']>;
};

export type PageContentWidgetHeadingLinkNodesInternalLinkInternalLink = Page;

export type PageContentWidgetHeadingLinkNodesInternalLink = {
  __typename?: 'PageContentWidgetHeadingLinkNodesInternalLink';
  label?: Maybe<Scalars['String']['output']>;
  internalLink?: Maybe<PageContentWidgetHeadingLinkNodesInternalLinkInternalLink>;
  anchor?: Maybe<Scalars['String']['output']>;
  styleInverse?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentWidgetHeadingLinkNodesExternalLink = {
  __typename?: 'PageContentWidgetHeadingLinkNodesExternalLink';
  label?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  styleInverse?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentWidgetHeadingLinkNodesFileLink = {
  __typename?: 'PageContentWidgetHeadingLinkNodesFileLink';
  label?: Maybe<Scalars['String']['output']>;
  fileLink?: Maybe<Scalars['String']['output']>;
  styleInverse?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentWidgetHeadingLinkNodes = PageContentWidgetHeadingLinkNodesInternalLink | PageContentWidgetHeadingLinkNodesExternalLink | PageContentWidgetHeadingLinkNodesFileLink;

export type PageContentWidgetHeading = {
  __typename?: 'PageContentWidgetHeading';
  title?: Maybe<Scalars['String']['output']>;
  imageNode?: Maybe<PageContentWidgetHeadingImageNode>;
  content?: Maybe<Scalars['JSON']['output']>;
  contentWithColumns?: Maybe<Scalars['Boolean']['output']>;
  linkNodes?: Maybe<Array<Maybe<PageContentWidgetHeadingLinkNodes>>>;
  withBackgroundImage?: Maybe<Scalars['String']['output']>;
  withBackgroundGradient?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentWidgetImageGridGridImageNodes = {
  __typename?: 'PageContentWidgetImageGridGridImageNodes';
  image?: Maybe<Scalars['String']['output']>;
  alt?: Maybe<Scalars['String']['output']>;
  credits?: Maybe<Scalars['String']['output']>;
  aspectRatio?: Maybe<Scalars['String']['output']>;
};

export type PageContentWidgetImageGridGrid = {
  __typename?: 'PageContentWidgetImageGridGrid';
  imageNodes?: Maybe<Array<Maybe<PageContentWidgetImageGridGridImageNodes>>>;
};

export type PageContentWidgetImageGrid = {
  __typename?: 'PageContentWidgetImageGrid';
  grid?: Maybe<Array<Maybe<PageContentWidgetImageGridGrid>>>;
  withBackgroundImage?: Maybe<Scalars['String']['output']>;
  withBackgroundGradient?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentWidgetParagraphStackImageNode = {
  __typename?: 'PageContentWidgetParagraphStackImageNode';
  image?: Maybe<Scalars['String']['output']>;
  alt?: Maybe<Scalars['String']['output']>;
  credits?: Maybe<Scalars['String']['output']>;
  aspectRatio?: Maybe<Scalars['String']['output']>;
};

export type PageContentWidgetParagraphStackSpecs = {
  __typename?: 'PageContentWidgetParagraphStackSpecs';
  title?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['JSON']['output']>;
};

export type PageContentWidgetParagraphStack = {
  __typename?: 'PageContentWidgetParagraphStack';
  title?: Maybe<Scalars['String']['output']>;
  imageNode?: Maybe<PageContentWidgetParagraphStackImageNode>;
  specs?: Maybe<Array<Maybe<PageContentWidgetParagraphStackSpecs>>>;
  withBackgroundImage?: Maybe<Scalars['String']['output']>;
  withBackgroundGradient?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentWidgetParagraphGridGridImageNode = {
  __typename?: 'PageContentWidgetParagraphGridGridImageNode';
  image?: Maybe<Scalars['String']['output']>;
  alt?: Maybe<Scalars['String']['output']>;
  credits?: Maybe<Scalars['String']['output']>;
};

export type PageContentWidgetParagraphGridGrid = {
  __typename?: 'PageContentWidgetParagraphGridGrid';
  title?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['JSON']['output']>;
  imageNode?: Maybe<PageContentWidgetParagraphGridGridImageNode>;
};

export type PageContentWidgetParagraphGrid = {
  __typename?: 'PageContentWidgetParagraphGrid';
  title?: Maybe<Scalars['String']['output']>;
  grid?: Maybe<Array<Maybe<PageContentWidgetParagraphGridGrid>>>;
  columns?: Maybe<Scalars['Float']['output']>;
};

export type PageContentWidgetCardsCardsImageNode = {
  __typename?: 'PageContentWidgetCardsCardsImageNode';
  image?: Maybe<Scalars['String']['output']>;
  alt?: Maybe<Scalars['String']['output']>;
  credits?: Maybe<Scalars['String']['output']>;
};

export type PageContentWidgetCardsCards = {
  __typename?: 'PageContentWidgetCardsCards';
  title?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  imageNode?: Maybe<PageContentWidgetCardsCardsImageNode>;
};

export type PageContentWidgetCards = {
  __typename?: 'PageContentWidgetCards';
  title?: Maybe<Scalars['String']['output']>;
  cards?: Maybe<Array<Maybe<PageContentWidgetCardsCards>>>;
  cardImageOnHover?: Maybe<Scalars['Boolean']['output']>;
  withBackgroundImage?: Maybe<Scalars['String']['output']>;
  withBackgroundGradient?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentWidgetBoxLinkNodesInternalLinkInternalLink = Page;

export type PageContentWidgetBoxLinkNodesInternalLink = {
  __typename?: 'PageContentWidgetBoxLinkNodesInternalLink';
  label?: Maybe<Scalars['String']['output']>;
  internalLink?: Maybe<PageContentWidgetBoxLinkNodesInternalLinkInternalLink>;
  anchor?: Maybe<Scalars['String']['output']>;
  styleInverse?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentWidgetBoxLinkNodesExternalLink = {
  __typename?: 'PageContentWidgetBoxLinkNodesExternalLink';
  label?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  styleInverse?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentWidgetBoxLinkNodesFileLink = {
  __typename?: 'PageContentWidgetBoxLinkNodesFileLink';
  label?: Maybe<Scalars['String']['output']>;
  fileLink?: Maybe<Scalars['String']['output']>;
  styleInverse?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentWidgetBoxLinkNodes = PageContentWidgetBoxLinkNodesInternalLink | PageContentWidgetBoxLinkNodesExternalLink | PageContentWidgetBoxLinkNodesFileLink;

export type PageContentWidgetBox = {
  __typename?: 'PageContentWidgetBox';
  title?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['JSON']['output']>;
  linkNodes?: Maybe<Array<Maybe<PageContentWidgetBoxLinkNodes>>>;
};

export type PageContentWidgetCustomContentLinkNodesInternalLinkInternalLink = Page;

export type PageContentWidgetCustomContentLinkNodesInternalLink = {
  __typename?: 'PageContentWidgetCustomContentLinkNodesInternalLink';
  label?: Maybe<Scalars['String']['output']>;
  internalLink?: Maybe<PageContentWidgetCustomContentLinkNodesInternalLinkInternalLink>;
  anchor?: Maybe<Scalars['String']['output']>;
  styleInverse?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentWidgetCustomContentLinkNodesExternalLink = {
  __typename?: 'PageContentWidgetCustomContentLinkNodesExternalLink';
  label?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  styleInverse?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentWidgetCustomContentLinkNodesFileLink = {
  __typename?: 'PageContentWidgetCustomContentLinkNodesFileLink';
  label?: Maybe<Scalars['String']['output']>;
  fileLink?: Maybe<Scalars['String']['output']>;
  styleInverse?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentWidgetCustomContentLinkNodes = PageContentWidgetCustomContentLinkNodesInternalLink | PageContentWidgetCustomContentLinkNodesExternalLink | PageContentWidgetCustomContentLinkNodesFileLink;

export type PageContentWidgetCustomContent = {
  __typename?: 'PageContentWidgetCustomContent';
  title?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['JSON']['output']>;
  linkNodes?: Maybe<Array<Maybe<PageContentWidgetCustomContentLinkNodes>>>;
};

export type PageContentWidgetProjectHeadingTagsTag = Tag;

export type PageContentWidgetProjectHeadingTags = {
  __typename?: 'PageContentWidgetProjectHeadingTags';
  tag?: Maybe<PageContentWidgetProjectHeadingTagsTag>;
};

export type PageContentWidgetProjectHeadingLinkNodesInternalLinkInternalLink = Page;

export type PageContentWidgetProjectHeadingLinkNodesInternalLink = {
  __typename?: 'PageContentWidgetProjectHeadingLinkNodesInternalLink';
  label?: Maybe<Scalars['String']['output']>;
  internalLink?: Maybe<PageContentWidgetProjectHeadingLinkNodesInternalLinkInternalLink>;
  anchor?: Maybe<Scalars['String']['output']>;
  styleInverse?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentWidgetProjectHeadingLinkNodesExternalLink = {
  __typename?: 'PageContentWidgetProjectHeadingLinkNodesExternalLink';
  label?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  styleInverse?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentWidgetProjectHeadingLinkNodesFileLink = {
  __typename?: 'PageContentWidgetProjectHeadingLinkNodesFileLink';
  label?: Maybe<Scalars['String']['output']>;
  fileLink?: Maybe<Scalars['String']['output']>;
  styleInverse?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentWidgetProjectHeadingLinkNodes = PageContentWidgetProjectHeadingLinkNodesInternalLink | PageContentWidgetProjectHeadingLinkNodesExternalLink | PageContentWidgetProjectHeadingLinkNodesFileLink;

export type PageContentWidgetProjectHeading = {
  __typename?: 'PageContentWidgetProjectHeading';
  title?: Maybe<Scalars['String']['output']>;
  client?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<PageContentWidgetProjectHeadingTags>>>;
  content?: Maybe<Scalars['JSON']['output']>;
  contentWithColumns?: Maybe<Scalars['Boolean']['output']>;
  linkNodes?: Maybe<Array<Maybe<PageContentWidgetProjectHeadingLinkNodes>>>;
  withBackgroundImage?: Maybe<Scalars['String']['output']>;
  withBackgroundGradient?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentWidgetHomeHeading = {
  __typename?: 'PageContentWidgetHomeHeading';
  richTitle?: Maybe<Scalars['String']['output']>;
  richSubtitle?: Maybe<Scalars['String']['output']>;
};

export type PageContentWidgetSkillsSkillsImageNode = {
  __typename?: 'PageContentWidgetSkillsSkillsImageNode';
  image?: Maybe<Scalars['String']['output']>;
  alt?: Maybe<Scalars['String']['output']>;
  credits?: Maybe<Scalars['String']['output']>;
};

export type PageContentWidgetSkillsSkills = {
  __typename?: 'PageContentWidgetSkillsSkills';
  name?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['JSON']['output']>;
  imageNode?: Maybe<PageContentWidgetSkillsSkillsImageNode>;
};

export type PageContentWidgetSkillsLinkNodesInternalLinkInternalLink = Page;

export type PageContentWidgetSkillsLinkNodesInternalLink = {
  __typename?: 'PageContentWidgetSkillsLinkNodesInternalLink';
  label?: Maybe<Scalars['String']['output']>;
  internalLink?: Maybe<PageContentWidgetSkillsLinkNodesInternalLinkInternalLink>;
  anchor?: Maybe<Scalars['String']['output']>;
  styleInverse?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentWidgetSkillsLinkNodesExternalLink = {
  __typename?: 'PageContentWidgetSkillsLinkNodesExternalLink';
  label?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  styleInverse?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentWidgetSkillsLinkNodesFileLink = {
  __typename?: 'PageContentWidgetSkillsLinkNodesFileLink';
  label?: Maybe<Scalars['String']['output']>;
  fileLink?: Maybe<Scalars['String']['output']>;
  styleInverse?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentWidgetSkillsLinkNodes = PageContentWidgetSkillsLinkNodesInternalLink | PageContentWidgetSkillsLinkNodesExternalLink | PageContentWidgetSkillsLinkNodesFileLink;

export type PageContentWidgetSkills = {
  __typename?: 'PageContentWidgetSkills';
  title?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  skills?: Maybe<Array<Maybe<PageContentWidgetSkillsSkills>>>;
  linkNodes?: Maybe<Array<Maybe<PageContentWidgetSkillsLinkNodes>>>;
  withBackgroundImage?: Maybe<Scalars['String']['output']>;
  withBackgroundGradient?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentWidgetProjectsLinkNodesInternalLinkInternalLink = Page;

export type PageContentWidgetProjectsLinkNodesInternalLink = {
  __typename?: 'PageContentWidgetProjectsLinkNodesInternalLink';
  label?: Maybe<Scalars['String']['output']>;
  internalLink?: Maybe<PageContentWidgetProjectsLinkNodesInternalLinkInternalLink>;
  anchor?: Maybe<Scalars['String']['output']>;
  styleInverse?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentWidgetProjectsLinkNodesExternalLink = {
  __typename?: 'PageContentWidgetProjectsLinkNodesExternalLink';
  label?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  styleInverse?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentWidgetProjectsLinkNodesFileLink = {
  __typename?: 'PageContentWidgetProjectsLinkNodesFileLink';
  label?: Maybe<Scalars['String']['output']>;
  fileLink?: Maybe<Scalars['String']['output']>;
  styleInverse?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentWidgetProjectsLinkNodes = PageContentWidgetProjectsLinkNodesInternalLink | PageContentWidgetProjectsLinkNodesExternalLink | PageContentWidgetProjectsLinkNodesFileLink;

export type PageContentWidgetProjects = {
  __typename?: 'PageContentWidgetProjects';
  title?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  intro?: Maybe<Scalars['JSON']['output']>;
  limit?: Maybe<Scalars['Float']['output']>;
  withFilter?: Maybe<Scalars['Boolean']['output']>;
  linkNodes?: Maybe<Array<Maybe<PageContentWidgetProjectsLinkNodes>>>;
  withBackgroundImage?: Maybe<Scalars['String']['output']>;
  withBackgroundGradient?: Maybe<Scalars['Boolean']['output']>;
};

export type PageContentWidgetContactForm = {
  __typename?: 'PageContentWidgetContactForm';
  title?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['JSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sendButton?: Maybe<Scalars['String']['output']>;
  resendButton?: Maybe<Scalars['String']['output']>;
  successMessage?: Maybe<Scalars['JSON']['output']>;
  errorMessage?: Maybe<Scalars['JSON']['output']>;
};

export type PageContentWidgetAnchor = {
  __typename?: 'PageContentWidgetAnchor';
  name?: Maybe<Scalars['String']['output']>;
};

export type PageContent = PageContentWidgetBannerImage | PageContentWidgetHeading | PageContentWidgetImageGrid | PageContentWidgetParagraphStack | PageContentWidgetParagraphGrid | PageContentWidgetCards | PageContentWidgetBox | PageContentWidgetCustomContent | PageContentWidgetProjectHeading | PageContentWidgetHomeHeading | PageContentWidgetSkills | PageContentWidgetProjects | PageContentWidgetContactForm | PageContentWidgetAnchor;

export type PageExtractImageNode = {
  __typename?: 'PageExtractImageNode';
  image?: Maybe<Scalars['String']['output']>;
  alt?: Maybe<Scalars['String']['output']>;
  credits?: Maybe<Scalars['String']['output']>;
};

export type PageExtract = {
  __typename?: 'PageExtract';
  title?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  imageNode?: Maybe<PageExtractImageNode>;
};

export type PageSeo = {
  __typename?: 'PageSeo';
  title?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  keywords?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
};

export type Page = Node & Document & {
  __typename?: 'Page';
  type?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  path: Scalars['String']['output'];
  parentPage?: Maybe<PageParentPage>;
  addedAt?: Maybe<Scalars['String']['output']>;
  draft?: Maybe<Scalars['Boolean']['output']>;
  content?: Maybe<Array<Maybe<PageContent>>>;
  extract?: Maybe<PageExtract>;
  seo?: Maybe<PageSeo>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type StringFilter = {
  startsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PageParentPageFilter = {
  page?: InputMaybe<PageFilter>;
};

export type DatetimeFilter = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BooleanFilter = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageFilter = {
  startsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PageContentWidgetBannerImageFilter = {
  image?: InputMaybe<ImageFilter>;
  alt?: InputMaybe<StringFilter>;
  credits?: InputMaybe<StringFilter>;
  aspectRatio?: InputMaybe<StringFilter>;
};

export type PageContentWidgetHeadingImageNodeFilter = {
  image?: InputMaybe<ImageFilter>;
  alt?: InputMaybe<StringFilter>;
  credits?: InputMaybe<StringFilter>;
};

export type RichTextFilter = {
  startsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentWidgetHeadingLinkNodesInternalLinkInternalLinkFilter = {
  page?: InputMaybe<PageFilter>;
};

export type PageContentWidgetHeadingLinkNodesInternalLinkFilter = {
  label?: InputMaybe<StringFilter>;
  internalLink?: InputMaybe<PageContentWidgetHeadingLinkNodesInternalLinkInternalLinkFilter>;
  anchor?: InputMaybe<StringFilter>;
  styleInverse?: InputMaybe<BooleanFilter>;
};

export type PageContentWidgetHeadingLinkNodesExternalLinkFilter = {
  label?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
  styleInverse?: InputMaybe<BooleanFilter>;
};

export type PageContentWidgetHeadingLinkNodesFileLinkFilter = {
  label?: InputMaybe<StringFilter>;
  fileLink?: InputMaybe<ImageFilter>;
  styleInverse?: InputMaybe<BooleanFilter>;
};

export type PageContentWidgetHeadingLinkNodesFilter = {
  internalLink?: InputMaybe<PageContentWidgetHeadingLinkNodesInternalLinkFilter>;
  externalLink?: InputMaybe<PageContentWidgetHeadingLinkNodesExternalLinkFilter>;
  fileLink?: InputMaybe<PageContentWidgetHeadingLinkNodesFileLinkFilter>;
};

export type PageContentWidgetHeadingFilter = {
  title?: InputMaybe<StringFilter>;
  imageNode?: InputMaybe<PageContentWidgetHeadingImageNodeFilter>;
  content?: InputMaybe<RichTextFilter>;
  contentWithColumns?: InputMaybe<BooleanFilter>;
  linkNodes?: InputMaybe<PageContentWidgetHeadingLinkNodesFilter>;
  withBackgroundImage?: InputMaybe<StringFilter>;
  withBackgroundGradient?: InputMaybe<BooleanFilter>;
};

export type PageContentWidgetImageGridGridImageNodesFilter = {
  image?: InputMaybe<ImageFilter>;
  alt?: InputMaybe<StringFilter>;
  credits?: InputMaybe<StringFilter>;
  aspectRatio?: InputMaybe<StringFilter>;
};

export type PageContentWidgetImageGridGridFilter = {
  imageNodes?: InputMaybe<PageContentWidgetImageGridGridImageNodesFilter>;
};

export type PageContentWidgetImageGridFilter = {
  grid?: InputMaybe<PageContentWidgetImageGridGridFilter>;
  withBackgroundImage?: InputMaybe<StringFilter>;
  withBackgroundGradient?: InputMaybe<BooleanFilter>;
};

export type PageContentWidgetParagraphStackImageNodeFilter = {
  image?: InputMaybe<ImageFilter>;
  alt?: InputMaybe<StringFilter>;
  credits?: InputMaybe<StringFilter>;
  aspectRatio?: InputMaybe<StringFilter>;
};

export type PageContentWidgetParagraphStackSpecsFilter = {
  title?: InputMaybe<StringFilter>;
  content?: InputMaybe<RichTextFilter>;
};

export type PageContentWidgetParagraphStackFilter = {
  title?: InputMaybe<StringFilter>;
  imageNode?: InputMaybe<PageContentWidgetParagraphStackImageNodeFilter>;
  specs?: InputMaybe<PageContentWidgetParagraphStackSpecsFilter>;
  withBackgroundImage?: InputMaybe<StringFilter>;
  withBackgroundGradient?: InputMaybe<BooleanFilter>;
};

export type PageContentWidgetParagraphGridGridImageNodeFilter = {
  image?: InputMaybe<ImageFilter>;
  alt?: InputMaybe<StringFilter>;
  credits?: InputMaybe<StringFilter>;
};

export type PageContentWidgetParagraphGridGridFilter = {
  title?: InputMaybe<StringFilter>;
  content?: InputMaybe<RichTextFilter>;
  imageNode?: InputMaybe<PageContentWidgetParagraphGridGridImageNodeFilter>;
};

export type NumberFilter = {
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type PageContentWidgetParagraphGridFilter = {
  title?: InputMaybe<StringFilter>;
  grid?: InputMaybe<PageContentWidgetParagraphGridGridFilter>;
  columns?: InputMaybe<NumberFilter>;
};

export type PageContentWidgetCardsCardsImageNodeFilter = {
  image?: InputMaybe<ImageFilter>;
  alt?: InputMaybe<StringFilter>;
  credits?: InputMaybe<StringFilter>;
};

export type PageContentWidgetCardsCardsFilter = {
  title?: InputMaybe<StringFilter>;
  content?: InputMaybe<StringFilter>;
  color?: InputMaybe<StringFilter>;
  imageNode?: InputMaybe<PageContentWidgetCardsCardsImageNodeFilter>;
};

export type PageContentWidgetCardsFilter = {
  title?: InputMaybe<StringFilter>;
  cards?: InputMaybe<PageContentWidgetCardsCardsFilter>;
  cardImageOnHover?: InputMaybe<BooleanFilter>;
  withBackgroundImage?: InputMaybe<StringFilter>;
  withBackgroundGradient?: InputMaybe<BooleanFilter>;
};

export type PageContentWidgetBoxLinkNodesInternalLinkInternalLinkFilter = {
  page?: InputMaybe<PageFilter>;
};

export type PageContentWidgetBoxLinkNodesInternalLinkFilter = {
  label?: InputMaybe<StringFilter>;
  internalLink?: InputMaybe<PageContentWidgetBoxLinkNodesInternalLinkInternalLinkFilter>;
  anchor?: InputMaybe<StringFilter>;
  styleInverse?: InputMaybe<BooleanFilter>;
};

export type PageContentWidgetBoxLinkNodesExternalLinkFilter = {
  label?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
  styleInverse?: InputMaybe<BooleanFilter>;
};

export type PageContentWidgetBoxLinkNodesFileLinkFilter = {
  label?: InputMaybe<StringFilter>;
  fileLink?: InputMaybe<ImageFilter>;
  styleInverse?: InputMaybe<BooleanFilter>;
};

export type PageContentWidgetBoxLinkNodesFilter = {
  internalLink?: InputMaybe<PageContentWidgetBoxLinkNodesInternalLinkFilter>;
  externalLink?: InputMaybe<PageContentWidgetBoxLinkNodesExternalLinkFilter>;
  fileLink?: InputMaybe<PageContentWidgetBoxLinkNodesFileLinkFilter>;
};

export type PageContentWidgetBoxFilter = {
  title?: InputMaybe<StringFilter>;
  content?: InputMaybe<RichTextFilter>;
  linkNodes?: InputMaybe<PageContentWidgetBoxLinkNodesFilter>;
};

export type PageContentWidgetCustomContentLinkNodesInternalLinkInternalLinkFilter = {
  page?: InputMaybe<PageFilter>;
};

export type PageContentWidgetCustomContentLinkNodesInternalLinkFilter = {
  label?: InputMaybe<StringFilter>;
  internalLink?: InputMaybe<PageContentWidgetCustomContentLinkNodesInternalLinkInternalLinkFilter>;
  anchor?: InputMaybe<StringFilter>;
  styleInverse?: InputMaybe<BooleanFilter>;
};

export type PageContentWidgetCustomContentLinkNodesExternalLinkFilter = {
  label?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
  styleInverse?: InputMaybe<BooleanFilter>;
};

export type PageContentWidgetCustomContentLinkNodesFileLinkFilter = {
  label?: InputMaybe<StringFilter>;
  fileLink?: InputMaybe<ImageFilter>;
  styleInverse?: InputMaybe<BooleanFilter>;
};

export type PageContentWidgetCustomContentLinkNodesFilter = {
  internalLink?: InputMaybe<PageContentWidgetCustomContentLinkNodesInternalLinkFilter>;
  externalLink?: InputMaybe<PageContentWidgetCustomContentLinkNodesExternalLinkFilter>;
  fileLink?: InputMaybe<PageContentWidgetCustomContentLinkNodesFileLinkFilter>;
};

export type PageContentWidgetCustomContentFilter = {
  title?: InputMaybe<StringFilter>;
  content?: InputMaybe<RichTextFilter>;
  linkNodes?: InputMaybe<PageContentWidgetCustomContentLinkNodesFilter>;
};

export type PageContentWidgetProjectHeadingTagsTagFilter = {
  tag?: InputMaybe<TagFilter>;
};

export type PageContentWidgetProjectHeadingTagsFilter = {
  tag?: InputMaybe<PageContentWidgetProjectHeadingTagsTagFilter>;
};

export type PageContentWidgetProjectHeadingLinkNodesInternalLinkInternalLinkFilter = {
  page?: InputMaybe<PageFilter>;
};

export type PageContentWidgetProjectHeadingLinkNodesInternalLinkFilter = {
  label?: InputMaybe<StringFilter>;
  internalLink?: InputMaybe<PageContentWidgetProjectHeadingLinkNodesInternalLinkInternalLinkFilter>;
  anchor?: InputMaybe<StringFilter>;
  styleInverse?: InputMaybe<BooleanFilter>;
};

export type PageContentWidgetProjectHeadingLinkNodesExternalLinkFilter = {
  label?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
  styleInverse?: InputMaybe<BooleanFilter>;
};

export type PageContentWidgetProjectHeadingLinkNodesFileLinkFilter = {
  label?: InputMaybe<StringFilter>;
  fileLink?: InputMaybe<ImageFilter>;
  styleInverse?: InputMaybe<BooleanFilter>;
};

export type PageContentWidgetProjectHeadingLinkNodesFilter = {
  internalLink?: InputMaybe<PageContentWidgetProjectHeadingLinkNodesInternalLinkFilter>;
  externalLink?: InputMaybe<PageContentWidgetProjectHeadingLinkNodesExternalLinkFilter>;
  fileLink?: InputMaybe<PageContentWidgetProjectHeadingLinkNodesFileLinkFilter>;
};

export type PageContentWidgetProjectHeadingFilter = {
  title?: InputMaybe<StringFilter>;
  client?: InputMaybe<StringFilter>;
  tags?: InputMaybe<PageContentWidgetProjectHeadingTagsFilter>;
  content?: InputMaybe<RichTextFilter>;
  contentWithColumns?: InputMaybe<BooleanFilter>;
  linkNodes?: InputMaybe<PageContentWidgetProjectHeadingLinkNodesFilter>;
  withBackgroundImage?: InputMaybe<StringFilter>;
  withBackgroundGradient?: InputMaybe<BooleanFilter>;
};

export type PageContentWidgetHomeHeadingFilter = {
  richTitle?: InputMaybe<StringFilter>;
  richSubtitle?: InputMaybe<StringFilter>;
};

export type PageContentWidgetSkillsSkillsImageNodeFilter = {
  image?: InputMaybe<ImageFilter>;
  alt?: InputMaybe<StringFilter>;
  credits?: InputMaybe<StringFilter>;
};

export type PageContentWidgetSkillsSkillsFilter = {
  name?: InputMaybe<StringFilter>;
  description?: InputMaybe<RichTextFilter>;
  imageNode?: InputMaybe<PageContentWidgetSkillsSkillsImageNodeFilter>;
};

export type PageContentWidgetSkillsLinkNodesInternalLinkInternalLinkFilter = {
  page?: InputMaybe<PageFilter>;
};

export type PageContentWidgetSkillsLinkNodesInternalLinkFilter = {
  label?: InputMaybe<StringFilter>;
  internalLink?: InputMaybe<PageContentWidgetSkillsLinkNodesInternalLinkInternalLinkFilter>;
  anchor?: InputMaybe<StringFilter>;
  styleInverse?: InputMaybe<BooleanFilter>;
};

export type PageContentWidgetSkillsLinkNodesExternalLinkFilter = {
  label?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
  styleInverse?: InputMaybe<BooleanFilter>;
};

export type PageContentWidgetSkillsLinkNodesFileLinkFilter = {
  label?: InputMaybe<StringFilter>;
  fileLink?: InputMaybe<ImageFilter>;
  styleInverse?: InputMaybe<BooleanFilter>;
};

export type PageContentWidgetSkillsLinkNodesFilter = {
  internalLink?: InputMaybe<PageContentWidgetSkillsLinkNodesInternalLinkFilter>;
  externalLink?: InputMaybe<PageContentWidgetSkillsLinkNodesExternalLinkFilter>;
  fileLink?: InputMaybe<PageContentWidgetSkillsLinkNodesFileLinkFilter>;
};

export type PageContentWidgetSkillsFilter = {
  title?: InputMaybe<StringFilter>;
  subtitle?: InputMaybe<StringFilter>;
  skills?: InputMaybe<PageContentWidgetSkillsSkillsFilter>;
  linkNodes?: InputMaybe<PageContentWidgetSkillsLinkNodesFilter>;
  withBackgroundImage?: InputMaybe<StringFilter>;
  withBackgroundGradient?: InputMaybe<BooleanFilter>;
};

export type PageContentWidgetProjectsLinkNodesInternalLinkInternalLinkFilter = {
  page?: InputMaybe<PageFilter>;
};

export type PageContentWidgetProjectsLinkNodesInternalLinkFilter = {
  label?: InputMaybe<StringFilter>;
  internalLink?: InputMaybe<PageContentWidgetProjectsLinkNodesInternalLinkInternalLinkFilter>;
  anchor?: InputMaybe<StringFilter>;
  styleInverse?: InputMaybe<BooleanFilter>;
};

export type PageContentWidgetProjectsLinkNodesExternalLinkFilter = {
  label?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
  styleInverse?: InputMaybe<BooleanFilter>;
};

export type PageContentWidgetProjectsLinkNodesFileLinkFilter = {
  label?: InputMaybe<StringFilter>;
  fileLink?: InputMaybe<ImageFilter>;
  styleInverse?: InputMaybe<BooleanFilter>;
};

export type PageContentWidgetProjectsLinkNodesFilter = {
  internalLink?: InputMaybe<PageContentWidgetProjectsLinkNodesInternalLinkFilter>;
  externalLink?: InputMaybe<PageContentWidgetProjectsLinkNodesExternalLinkFilter>;
  fileLink?: InputMaybe<PageContentWidgetProjectsLinkNodesFileLinkFilter>;
};

export type PageContentWidgetProjectsFilter = {
  title?: InputMaybe<StringFilter>;
  subtitle?: InputMaybe<StringFilter>;
  intro?: InputMaybe<RichTextFilter>;
  limit?: InputMaybe<NumberFilter>;
  withFilter?: InputMaybe<BooleanFilter>;
  linkNodes?: InputMaybe<PageContentWidgetProjectsLinkNodesFilter>;
  withBackgroundImage?: InputMaybe<StringFilter>;
  withBackgroundGradient?: InputMaybe<BooleanFilter>;
};

export type PageContentWidgetContactFormFilter = {
  title?: InputMaybe<StringFilter>;
  content?: InputMaybe<RichTextFilter>;
  name?: InputMaybe<StringFilter>;
  sendButton?: InputMaybe<StringFilter>;
  resendButton?: InputMaybe<StringFilter>;
  successMessage?: InputMaybe<RichTextFilter>;
  errorMessage?: InputMaybe<RichTextFilter>;
};

export type PageContentWidgetAnchorFilter = {
  name?: InputMaybe<StringFilter>;
};

export type PageContentFilter = {
  WidgetBannerImage?: InputMaybe<PageContentWidgetBannerImageFilter>;
  WidgetHeading?: InputMaybe<PageContentWidgetHeadingFilter>;
  WidgetImageGrid?: InputMaybe<PageContentWidgetImageGridFilter>;
  WidgetParagraphStack?: InputMaybe<PageContentWidgetParagraphStackFilter>;
  WidgetParagraphGrid?: InputMaybe<PageContentWidgetParagraphGridFilter>;
  WidgetCards?: InputMaybe<PageContentWidgetCardsFilter>;
  WidgetBox?: InputMaybe<PageContentWidgetBoxFilter>;
  WidgetCustomContent?: InputMaybe<PageContentWidgetCustomContentFilter>;
  WidgetProjectHeading?: InputMaybe<PageContentWidgetProjectHeadingFilter>;
  WidgetHomeHeading?: InputMaybe<PageContentWidgetHomeHeadingFilter>;
  WidgetSkills?: InputMaybe<PageContentWidgetSkillsFilter>;
  WidgetProjects?: InputMaybe<PageContentWidgetProjectsFilter>;
  WidgetContactForm?: InputMaybe<PageContentWidgetContactFormFilter>;
  WidgetAnchor?: InputMaybe<PageContentWidgetAnchorFilter>;
};

export type PageExtractImageNodeFilter = {
  image?: InputMaybe<ImageFilter>;
  alt?: InputMaybe<StringFilter>;
  credits?: InputMaybe<StringFilter>;
};

export type PageExtractFilter = {
  title?: InputMaybe<StringFilter>;
  summary?: InputMaybe<StringFilter>;
  imageNode?: InputMaybe<PageExtractImageNodeFilter>;
};

export type PageSeoFilter = {
  title?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  keywords?: InputMaybe<StringFilter>;
  image?: InputMaybe<ImageFilter>;
};

export type PageFilter = {
  type?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  path?: InputMaybe<StringFilter>;
  parentPage?: InputMaybe<PageParentPageFilter>;
  addedAt?: InputMaybe<DatetimeFilter>;
  draft?: InputMaybe<BooleanFilter>;
  content?: InputMaybe<PageContentFilter>;
  extract?: InputMaybe<PageExtractFilter>;
  seo?: InputMaybe<PageSeoFilter>;
};

export type PageConnectionEdges = {
  __typename?: 'PageConnectionEdges';
  cursor: Scalars['String']['output'];
  node?: Maybe<Page>;
};

export type PageConnection = Connection & {
  __typename?: 'PageConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
  edges?: Maybe<Array<Maybe<PageConnectionEdges>>>;
};

export type MenuLinkNodesInternalLinkInternalLink = Page;

export type MenuLinkNodesInternalLink = {
  __typename?: 'MenuLinkNodesInternalLink';
  label?: Maybe<Scalars['String']['output']>;
  internalLink?: Maybe<MenuLinkNodesInternalLinkInternalLink>;
  anchor?: Maybe<Scalars['String']['output']>;
  styleInverse?: Maybe<Scalars['Boolean']['output']>;
};

export type MenuLinkNodesExternalLink = {
  __typename?: 'MenuLinkNodesExternalLink';
  label?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  styleInverse?: Maybe<Scalars['Boolean']['output']>;
};

export type MenuLinkNodesFileLink = {
  __typename?: 'MenuLinkNodesFileLink';
  label?: Maybe<Scalars['String']['output']>;
  fileLink?: Maybe<Scalars['String']['output']>;
  styleInverse?: Maybe<Scalars['Boolean']['output']>;
};

export type MenuLinkNodes = MenuLinkNodesInternalLink | MenuLinkNodesExternalLink | MenuLinkNodesFileLink;

export type Menu = Node & Document & {
  __typename?: 'Menu';
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['String']['output']>;
  linkNodes?: Maybe<Array<Maybe<MenuLinkNodes>>>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type MenuLinkNodesInternalLinkInternalLinkFilter = {
  page?: InputMaybe<PageFilter>;
};

export type MenuLinkNodesInternalLinkFilter = {
  label?: InputMaybe<StringFilter>;
  internalLink?: InputMaybe<MenuLinkNodesInternalLinkInternalLinkFilter>;
  anchor?: InputMaybe<StringFilter>;
  styleInverse?: InputMaybe<BooleanFilter>;
};

export type MenuLinkNodesExternalLinkFilter = {
  label?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
  styleInverse?: InputMaybe<BooleanFilter>;
};

export type MenuLinkNodesFileLinkFilter = {
  label?: InputMaybe<StringFilter>;
  fileLink?: InputMaybe<ImageFilter>;
  styleInverse?: InputMaybe<BooleanFilter>;
};

export type MenuLinkNodesFilter = {
  internalLink?: InputMaybe<MenuLinkNodesInternalLinkFilter>;
  externalLink?: InputMaybe<MenuLinkNodesExternalLinkFilter>;
  fileLink?: InputMaybe<MenuLinkNodesFileLinkFilter>;
};

export type MenuFilter = {
  name?: InputMaybe<StringFilter>;
  position?: InputMaybe<StringFilter>;
  linkNodes?: InputMaybe<MenuLinkNodesFilter>;
};

export type MenuConnectionEdges = {
  __typename?: 'MenuConnectionEdges';
  cursor: Scalars['String']['output'];
  node?: Maybe<Menu>;
};

export type MenuConnection = Connection & {
  __typename?: 'MenuConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
  edges?: Maybe<Array<Maybe<MenuConnectionEdges>>>;
};

export type Tag = Node & Document & {
  __typename?: 'Tag';
  tag: Scalars['String']['output'];
  color?: Maybe<Scalars['String']['output']>;
  order: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type TagFilter = {
  tag?: InputMaybe<StringFilter>;
  color?: InputMaybe<StringFilter>;
  order?: InputMaybe<NumberFilter>;
};

export type TagConnectionEdges = {
  __typename?: 'TagConnectionEdges';
  cursor: Scalars['String']['output'];
  node?: Maybe<Tag>;
};

export type TagConnection = Connection & {
  __typename?: 'TagConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
  edges?: Maybe<Array<Maybe<TagConnectionEdges>>>;
};

export type SettingsGeneralSettings = Node & Document & {
  __typename?: 'SettingsGeneralSettings';
  title: Scalars['String']['output'];
  websiteName: Scalars['String']['output'];
  websiteDescription?: Maybe<Scalars['String']['output']>;
  websiteKeywords?: Maybe<Scalars['String']['output']>;
  websiteLogo?: Maybe<Scalars['String']['output']>;
  websiteIcon?: Maybe<Scalars['String']['output']>;
  websiteTop?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type SettingsSocialNetworkSettingsPlatforms = {
  __typename?: 'SettingsSocialNetworkSettingsPlatforms';
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type SettingsSocialNetworkSettings = Node & Document & {
  __typename?: 'SettingsSocialNetworkSettings';
  title: Scalars['String']['output'];
  websiteShareImage?: Maybe<Scalars['String']['output']>;
  platforms?: Maybe<Array<Maybe<SettingsSocialNetworkSettingsPlatforms>>>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type SettingsTrackingSettings = Node & Document & {
  __typename?: 'SettingsTrackingSettings';
  title: Scalars['String']['output'];
  googleAnalyticsId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type SettingsContactSettingsContactsLinkNodesInternalLinkInternalLink = Page;

export type SettingsContactSettingsContactsLinkNodesInternalLink = {
  __typename?: 'SettingsContactSettingsContactsLinkNodesInternalLink';
  label?: Maybe<Scalars['String']['output']>;
  internalLink?: Maybe<SettingsContactSettingsContactsLinkNodesInternalLinkInternalLink>;
  anchor?: Maybe<Scalars['String']['output']>;
  styleInverse?: Maybe<Scalars['Boolean']['output']>;
};

export type SettingsContactSettingsContactsLinkNodesExternalLink = {
  __typename?: 'SettingsContactSettingsContactsLinkNodesExternalLink';
  label?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  styleInverse?: Maybe<Scalars['Boolean']['output']>;
};

export type SettingsContactSettingsContactsLinkNodesFileLink = {
  __typename?: 'SettingsContactSettingsContactsLinkNodesFileLink';
  label?: Maybe<Scalars['String']['output']>;
  fileLink?: Maybe<Scalars['String']['output']>;
  styleInverse?: Maybe<Scalars['Boolean']['output']>;
};

export type SettingsContactSettingsContactsLinkNodes = SettingsContactSettingsContactsLinkNodesInternalLink | SettingsContactSettingsContactsLinkNodesExternalLink | SettingsContactSettingsContactsLinkNodesFileLink;

export type SettingsContactSettingsContactsImageNode = {
  __typename?: 'SettingsContactSettingsContactsImageNode';
  image?: Maybe<Scalars['String']['output']>;
  alt?: Maybe<Scalars['String']['output']>;
  credits?: Maybe<Scalars['String']['output']>;
};

export type SettingsContactSettingsContacts = {
  __typename?: 'SettingsContactSettingsContacts';
  name: Scalars['String']['output'];
  linkNodes?: Maybe<Array<Maybe<SettingsContactSettingsContactsLinkNodes>>>;
  imageNode?: Maybe<SettingsContactSettingsContactsImageNode>;
};

export type SettingsContactSettings = Node & Document & {
  __typename?: 'SettingsContactSettings';
  title: Scalars['String']['output'];
  contacts?: Maybe<Array<Maybe<SettingsContactSettingsContacts>>>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type SettingsProjectSettingsPaginationLinkNodesInternalLinkInternalLink = Page;

export type SettingsProjectSettingsPaginationLinkNodesInternalLink = {
  __typename?: 'SettingsProjectSettingsPaginationLinkNodesInternalLink';
  label?: Maybe<Scalars['String']['output']>;
  internalLink?: Maybe<SettingsProjectSettingsPaginationLinkNodesInternalLinkInternalLink>;
  anchor?: Maybe<Scalars['String']['output']>;
  styleInverse?: Maybe<Scalars['Boolean']['output']>;
};

export type SettingsProjectSettingsPaginationLinkNodesExternalLink = {
  __typename?: 'SettingsProjectSettingsPaginationLinkNodesExternalLink';
  label?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  styleInverse?: Maybe<Scalars['Boolean']['output']>;
};

export type SettingsProjectSettingsPaginationLinkNodesFileLink = {
  __typename?: 'SettingsProjectSettingsPaginationLinkNodesFileLink';
  label?: Maybe<Scalars['String']['output']>;
  fileLink?: Maybe<Scalars['String']['output']>;
  styleInverse?: Maybe<Scalars['Boolean']['output']>;
};

export type SettingsProjectSettingsPaginationLinkNodes = SettingsProjectSettingsPaginationLinkNodesInternalLink | SettingsProjectSettingsPaginationLinkNodesExternalLink | SettingsProjectSettingsPaginationLinkNodesFileLink;

export type SettingsProjectSettingsPagination = {
  __typename?: 'SettingsProjectSettingsPagination';
  title?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  limit?: Maybe<Scalars['Float']['output']>;
  linkNodes?: Maybe<Array<Maybe<SettingsProjectSettingsPaginationLinkNodes>>>;
};

export type SettingsProjectSettings = Node & Document & {
  __typename?: 'SettingsProjectSettings';
  title: Scalars['String']['output'];
  pagination?: Maybe<SettingsProjectSettingsPagination>;
  id: Scalars['ID']['output'];
  _sys: SystemInfo;
  _values: Scalars['JSON']['output'];
};

export type Settings = SettingsGeneralSettings | SettingsSocialNetworkSettings | SettingsTrackingSettings | SettingsContactSettings | SettingsProjectSettings;

export type SettingsGeneralSettingsFilter = {
  title?: InputMaybe<StringFilter>;
  websiteName?: InputMaybe<StringFilter>;
  websiteDescription?: InputMaybe<StringFilter>;
  websiteKeywords?: InputMaybe<StringFilter>;
  websiteLogo?: InputMaybe<ImageFilter>;
  websiteIcon?: InputMaybe<ImageFilter>;
  websiteTop?: InputMaybe<ImageFilter>;
};

export type SettingsSocialNetworkSettingsPlatformsFilter = {
  name?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
};

export type SettingsSocialNetworkSettingsFilter = {
  title?: InputMaybe<StringFilter>;
  websiteShareImage?: InputMaybe<ImageFilter>;
  platforms?: InputMaybe<SettingsSocialNetworkSettingsPlatformsFilter>;
};

export type SettingsTrackingSettingsFilter = {
  title?: InputMaybe<StringFilter>;
  googleAnalyticsId?: InputMaybe<StringFilter>;
};

export type SettingsContactSettingsContactsLinkNodesInternalLinkInternalLinkFilter = {
  page?: InputMaybe<PageFilter>;
};

export type SettingsContactSettingsContactsLinkNodesInternalLinkFilter = {
  label?: InputMaybe<StringFilter>;
  internalLink?: InputMaybe<SettingsContactSettingsContactsLinkNodesInternalLinkInternalLinkFilter>;
  anchor?: InputMaybe<StringFilter>;
  styleInverse?: InputMaybe<BooleanFilter>;
};

export type SettingsContactSettingsContactsLinkNodesExternalLinkFilter = {
  label?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
  styleInverse?: InputMaybe<BooleanFilter>;
};

export type SettingsContactSettingsContactsLinkNodesFileLinkFilter = {
  label?: InputMaybe<StringFilter>;
  fileLink?: InputMaybe<ImageFilter>;
  styleInverse?: InputMaybe<BooleanFilter>;
};

export type SettingsContactSettingsContactsLinkNodesFilter = {
  internalLink?: InputMaybe<SettingsContactSettingsContactsLinkNodesInternalLinkFilter>;
  externalLink?: InputMaybe<SettingsContactSettingsContactsLinkNodesExternalLinkFilter>;
  fileLink?: InputMaybe<SettingsContactSettingsContactsLinkNodesFileLinkFilter>;
};

export type SettingsContactSettingsContactsImageNodeFilter = {
  image?: InputMaybe<ImageFilter>;
  alt?: InputMaybe<StringFilter>;
  credits?: InputMaybe<StringFilter>;
};

export type SettingsContactSettingsContactsFilter = {
  name?: InputMaybe<StringFilter>;
  linkNodes?: InputMaybe<SettingsContactSettingsContactsLinkNodesFilter>;
  imageNode?: InputMaybe<SettingsContactSettingsContactsImageNodeFilter>;
};

export type SettingsContactSettingsFilter = {
  title?: InputMaybe<StringFilter>;
  contacts?: InputMaybe<SettingsContactSettingsContactsFilter>;
};

export type SettingsProjectSettingsPaginationLinkNodesInternalLinkInternalLinkFilter = {
  page?: InputMaybe<PageFilter>;
};

export type SettingsProjectSettingsPaginationLinkNodesInternalLinkFilter = {
  label?: InputMaybe<StringFilter>;
  internalLink?: InputMaybe<SettingsProjectSettingsPaginationLinkNodesInternalLinkInternalLinkFilter>;
  anchor?: InputMaybe<StringFilter>;
  styleInverse?: InputMaybe<BooleanFilter>;
};

export type SettingsProjectSettingsPaginationLinkNodesExternalLinkFilter = {
  label?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
  styleInverse?: InputMaybe<BooleanFilter>;
};

export type SettingsProjectSettingsPaginationLinkNodesFileLinkFilter = {
  label?: InputMaybe<StringFilter>;
  fileLink?: InputMaybe<ImageFilter>;
  styleInverse?: InputMaybe<BooleanFilter>;
};

export type SettingsProjectSettingsPaginationLinkNodesFilter = {
  internalLink?: InputMaybe<SettingsProjectSettingsPaginationLinkNodesInternalLinkFilter>;
  externalLink?: InputMaybe<SettingsProjectSettingsPaginationLinkNodesExternalLinkFilter>;
  fileLink?: InputMaybe<SettingsProjectSettingsPaginationLinkNodesFileLinkFilter>;
};

export type SettingsProjectSettingsPaginationFilter = {
  title?: InputMaybe<StringFilter>;
  subtitle?: InputMaybe<StringFilter>;
  limit?: InputMaybe<NumberFilter>;
  linkNodes?: InputMaybe<SettingsProjectSettingsPaginationLinkNodesFilter>;
};

export type SettingsProjectSettingsFilter = {
  title?: InputMaybe<StringFilter>;
  pagination?: InputMaybe<SettingsProjectSettingsPaginationFilter>;
};

export type SettingsFilter = {
  generalSettings?: InputMaybe<SettingsGeneralSettingsFilter>;
  socialNetworkSettings?: InputMaybe<SettingsSocialNetworkSettingsFilter>;
  trackingSettings?: InputMaybe<SettingsTrackingSettingsFilter>;
  contactSettings?: InputMaybe<SettingsContactSettingsFilter>;
  projectSettings?: InputMaybe<SettingsProjectSettingsFilter>;
};

export type SettingsConnectionEdges = {
  __typename?: 'SettingsConnectionEdges';
  cursor: Scalars['String']['output'];
  node?: Maybe<Settings>;
};

export type SettingsConnection = Connection & {
  __typename?: 'SettingsConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
  edges?: Maybe<Array<Maybe<SettingsConnectionEdges>>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addPendingDocument: DocumentNode;
  updateDocument: DocumentNode;
  deleteDocument: DocumentNode;
  createDocument: DocumentNode;
  updatePage: Page;
  createPage: Page;
  updateMenu: Menu;
  createMenu: Menu;
  updateTag: Tag;
  createTag: Tag;
  updateSettings: Settings;
  createSettings: Settings;
};


export type MutationAddPendingDocumentArgs = {
  collection: Scalars['String']['input'];
  relativePath: Scalars['String']['input'];
  template?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateDocumentArgs = {
  collection?: InputMaybe<Scalars['String']['input']>;
  relativePath: Scalars['String']['input'];
  params: DocumentUpdateMutation;
};


export type MutationDeleteDocumentArgs = {
  collection?: InputMaybe<Scalars['String']['input']>;
  relativePath: Scalars['String']['input'];
};


export type MutationCreateDocumentArgs = {
  collection?: InputMaybe<Scalars['String']['input']>;
  relativePath: Scalars['String']['input'];
  params: DocumentMutation;
};


export type MutationUpdatePageArgs = {
  relativePath: Scalars['String']['input'];
  params: PageMutation;
};


export type MutationCreatePageArgs = {
  relativePath: Scalars['String']['input'];
  params: PageMutation;
};


export type MutationUpdateMenuArgs = {
  relativePath: Scalars['String']['input'];
  params: MenuMutation;
};


export type MutationCreateMenuArgs = {
  relativePath: Scalars['String']['input'];
  params: MenuMutation;
};


export type MutationUpdateTagArgs = {
  relativePath: Scalars['String']['input'];
  params: TagMutation;
};


export type MutationCreateTagArgs = {
  relativePath: Scalars['String']['input'];
  params: TagMutation;
};


export type MutationUpdateSettingsArgs = {
  relativePath: Scalars['String']['input'];
  params: SettingsMutation;
};


export type MutationCreateSettingsArgs = {
  relativePath: Scalars['String']['input'];
  params: SettingsMutation;
};

export type DocumentUpdateMutation = {
  page?: InputMaybe<PageMutation>;
  menu?: InputMaybe<MenuMutation>;
  tag?: InputMaybe<TagMutation>;
  settings?: InputMaybe<SettingsMutation>;
  relativePath?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentMutation = {
  page?: InputMaybe<PageMutation>;
  menu?: InputMaybe<MenuMutation>;
  tag?: InputMaybe<TagMutation>;
  settings?: InputMaybe<SettingsMutation>;
};

export type PageContentWidgetBannerImageMutation = {
  image?: InputMaybe<Scalars['String']['input']>;
  alt?: InputMaybe<Scalars['String']['input']>;
  credits?: InputMaybe<Scalars['String']['input']>;
  aspectRatio?: InputMaybe<Scalars['String']['input']>;
};

export type PageContentWidgetHeadingImageNodeMutation = {
  image?: InputMaybe<Scalars['String']['input']>;
  alt?: InputMaybe<Scalars['String']['input']>;
  credits?: InputMaybe<Scalars['String']['input']>;
};

export type PageContentWidgetHeadingLinkNodesInternalLinkMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  internalLink?: InputMaybe<Scalars['String']['input']>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  styleInverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentWidgetHeadingLinkNodesExternalLinkMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  styleInverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentWidgetHeadingLinkNodesFileLinkMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  fileLink?: InputMaybe<Scalars['String']['input']>;
  styleInverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentWidgetHeadingLinkNodesMutation = {
  internalLink?: InputMaybe<PageContentWidgetHeadingLinkNodesInternalLinkMutation>;
  externalLink?: InputMaybe<PageContentWidgetHeadingLinkNodesExternalLinkMutation>;
  fileLink?: InputMaybe<PageContentWidgetHeadingLinkNodesFileLinkMutation>;
};

export type PageContentWidgetHeadingMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  imageNode?: InputMaybe<PageContentWidgetHeadingImageNodeMutation>;
  content?: InputMaybe<Scalars['JSON']['input']>;
  contentWithColumns?: InputMaybe<Scalars['Boolean']['input']>;
  linkNodes?: InputMaybe<Array<InputMaybe<PageContentWidgetHeadingLinkNodesMutation>>>;
  withBackgroundImage?: InputMaybe<Scalars['String']['input']>;
  withBackgroundGradient?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentWidgetImageGridGridImageNodesMutation = {
  image?: InputMaybe<Scalars['String']['input']>;
  alt?: InputMaybe<Scalars['String']['input']>;
  credits?: InputMaybe<Scalars['String']['input']>;
  aspectRatio?: InputMaybe<Scalars['String']['input']>;
};

export type PageContentWidgetImageGridGridMutation = {
  imageNodes?: InputMaybe<Array<InputMaybe<PageContentWidgetImageGridGridImageNodesMutation>>>;
};

export type PageContentWidgetImageGridMutation = {
  grid?: InputMaybe<Array<InputMaybe<PageContentWidgetImageGridGridMutation>>>;
  withBackgroundImage?: InputMaybe<Scalars['String']['input']>;
  withBackgroundGradient?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentWidgetParagraphStackImageNodeMutation = {
  image?: InputMaybe<Scalars['String']['input']>;
  alt?: InputMaybe<Scalars['String']['input']>;
  credits?: InputMaybe<Scalars['String']['input']>;
  aspectRatio?: InputMaybe<Scalars['String']['input']>;
};

export type PageContentWidgetParagraphStackSpecsMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['JSON']['input']>;
};

export type PageContentWidgetParagraphStackMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  imageNode?: InputMaybe<PageContentWidgetParagraphStackImageNodeMutation>;
  specs?: InputMaybe<Array<InputMaybe<PageContentWidgetParagraphStackSpecsMutation>>>;
  withBackgroundImage?: InputMaybe<Scalars['String']['input']>;
  withBackgroundGradient?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentWidgetParagraphGridGridImageNodeMutation = {
  image?: InputMaybe<Scalars['String']['input']>;
  alt?: InputMaybe<Scalars['String']['input']>;
  credits?: InputMaybe<Scalars['String']['input']>;
};

export type PageContentWidgetParagraphGridGridMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['JSON']['input']>;
  imageNode?: InputMaybe<PageContentWidgetParagraphGridGridImageNodeMutation>;
};

export type PageContentWidgetParagraphGridMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  grid?: InputMaybe<Array<InputMaybe<PageContentWidgetParagraphGridGridMutation>>>;
  columns?: InputMaybe<Scalars['Float']['input']>;
};

export type PageContentWidgetCardsCardsImageNodeMutation = {
  image?: InputMaybe<Scalars['String']['input']>;
  alt?: InputMaybe<Scalars['String']['input']>;
  credits?: InputMaybe<Scalars['String']['input']>;
};

export type PageContentWidgetCardsCardsMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  imageNode?: InputMaybe<PageContentWidgetCardsCardsImageNodeMutation>;
};

export type PageContentWidgetCardsMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  cards?: InputMaybe<Array<InputMaybe<PageContentWidgetCardsCardsMutation>>>;
  cardImageOnHover?: InputMaybe<Scalars['Boolean']['input']>;
  withBackgroundImage?: InputMaybe<Scalars['String']['input']>;
  withBackgroundGradient?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentWidgetBoxLinkNodesInternalLinkMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  internalLink?: InputMaybe<Scalars['String']['input']>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  styleInverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentWidgetBoxLinkNodesExternalLinkMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  styleInverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentWidgetBoxLinkNodesFileLinkMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  fileLink?: InputMaybe<Scalars['String']['input']>;
  styleInverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentWidgetBoxLinkNodesMutation = {
  internalLink?: InputMaybe<PageContentWidgetBoxLinkNodesInternalLinkMutation>;
  externalLink?: InputMaybe<PageContentWidgetBoxLinkNodesExternalLinkMutation>;
  fileLink?: InputMaybe<PageContentWidgetBoxLinkNodesFileLinkMutation>;
};

export type PageContentWidgetBoxMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['JSON']['input']>;
  linkNodes?: InputMaybe<Array<InputMaybe<PageContentWidgetBoxLinkNodesMutation>>>;
};

export type PageContentWidgetCustomContentLinkNodesInternalLinkMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  internalLink?: InputMaybe<Scalars['String']['input']>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  styleInverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentWidgetCustomContentLinkNodesExternalLinkMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  styleInverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentWidgetCustomContentLinkNodesFileLinkMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  fileLink?: InputMaybe<Scalars['String']['input']>;
  styleInverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentWidgetCustomContentLinkNodesMutation = {
  internalLink?: InputMaybe<PageContentWidgetCustomContentLinkNodesInternalLinkMutation>;
  externalLink?: InputMaybe<PageContentWidgetCustomContentLinkNodesExternalLinkMutation>;
  fileLink?: InputMaybe<PageContentWidgetCustomContentLinkNodesFileLinkMutation>;
};

export type PageContentWidgetCustomContentMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['JSON']['input']>;
  linkNodes?: InputMaybe<Array<InputMaybe<PageContentWidgetCustomContentLinkNodesMutation>>>;
};

export type PageContentWidgetProjectHeadingTagsMutation = {
  tag?: InputMaybe<Scalars['String']['input']>;
};

export type PageContentWidgetProjectHeadingLinkNodesInternalLinkMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  internalLink?: InputMaybe<Scalars['String']['input']>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  styleInverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentWidgetProjectHeadingLinkNodesExternalLinkMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  styleInverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentWidgetProjectHeadingLinkNodesFileLinkMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  fileLink?: InputMaybe<Scalars['String']['input']>;
  styleInverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentWidgetProjectHeadingLinkNodesMutation = {
  internalLink?: InputMaybe<PageContentWidgetProjectHeadingLinkNodesInternalLinkMutation>;
  externalLink?: InputMaybe<PageContentWidgetProjectHeadingLinkNodesExternalLinkMutation>;
  fileLink?: InputMaybe<PageContentWidgetProjectHeadingLinkNodesFileLinkMutation>;
};

export type PageContentWidgetProjectHeadingMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  client?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<PageContentWidgetProjectHeadingTagsMutation>>>;
  content?: InputMaybe<Scalars['JSON']['input']>;
  contentWithColumns?: InputMaybe<Scalars['Boolean']['input']>;
  linkNodes?: InputMaybe<Array<InputMaybe<PageContentWidgetProjectHeadingLinkNodesMutation>>>;
  withBackgroundImage?: InputMaybe<Scalars['String']['input']>;
  withBackgroundGradient?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentWidgetHomeHeadingMutation = {
  richTitle?: InputMaybe<Scalars['String']['input']>;
  richSubtitle?: InputMaybe<Scalars['String']['input']>;
};

export type PageContentWidgetSkillsSkillsImageNodeMutation = {
  image?: InputMaybe<Scalars['String']['input']>;
  alt?: InputMaybe<Scalars['String']['input']>;
  credits?: InputMaybe<Scalars['String']['input']>;
};

export type PageContentWidgetSkillsSkillsMutation = {
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  imageNode?: InputMaybe<PageContentWidgetSkillsSkillsImageNodeMutation>;
};

export type PageContentWidgetSkillsLinkNodesInternalLinkMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  internalLink?: InputMaybe<Scalars['String']['input']>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  styleInverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentWidgetSkillsLinkNodesExternalLinkMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  styleInverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentWidgetSkillsLinkNodesFileLinkMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  fileLink?: InputMaybe<Scalars['String']['input']>;
  styleInverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentWidgetSkillsLinkNodesMutation = {
  internalLink?: InputMaybe<PageContentWidgetSkillsLinkNodesInternalLinkMutation>;
  externalLink?: InputMaybe<PageContentWidgetSkillsLinkNodesExternalLinkMutation>;
  fileLink?: InputMaybe<PageContentWidgetSkillsLinkNodesFileLinkMutation>;
};

export type PageContentWidgetSkillsMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  skills?: InputMaybe<Array<InputMaybe<PageContentWidgetSkillsSkillsMutation>>>;
  linkNodes?: InputMaybe<Array<InputMaybe<PageContentWidgetSkillsLinkNodesMutation>>>;
  withBackgroundImage?: InputMaybe<Scalars['String']['input']>;
  withBackgroundGradient?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentWidgetProjectsLinkNodesInternalLinkMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  internalLink?: InputMaybe<Scalars['String']['input']>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  styleInverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentWidgetProjectsLinkNodesExternalLinkMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  styleInverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentWidgetProjectsLinkNodesFileLinkMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  fileLink?: InputMaybe<Scalars['String']['input']>;
  styleInverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentWidgetProjectsLinkNodesMutation = {
  internalLink?: InputMaybe<PageContentWidgetProjectsLinkNodesInternalLinkMutation>;
  externalLink?: InputMaybe<PageContentWidgetProjectsLinkNodesExternalLinkMutation>;
  fileLink?: InputMaybe<PageContentWidgetProjectsLinkNodesFileLinkMutation>;
};

export type PageContentWidgetProjectsMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  intro?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  withFilter?: InputMaybe<Scalars['Boolean']['input']>;
  linkNodes?: InputMaybe<Array<InputMaybe<PageContentWidgetProjectsLinkNodesMutation>>>;
  withBackgroundImage?: InputMaybe<Scalars['String']['input']>;
  withBackgroundGradient?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageContentWidgetContactFormMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sendButton?: InputMaybe<Scalars['String']['input']>;
  resendButton?: InputMaybe<Scalars['String']['input']>;
  successMessage?: InputMaybe<Scalars['JSON']['input']>;
  errorMessage?: InputMaybe<Scalars['JSON']['input']>;
};

export type PageContentWidgetAnchorMutation = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type PageContentMutation = {
  WidgetBannerImage?: InputMaybe<PageContentWidgetBannerImageMutation>;
  WidgetHeading?: InputMaybe<PageContentWidgetHeadingMutation>;
  WidgetImageGrid?: InputMaybe<PageContentWidgetImageGridMutation>;
  WidgetParagraphStack?: InputMaybe<PageContentWidgetParagraphStackMutation>;
  WidgetParagraphGrid?: InputMaybe<PageContentWidgetParagraphGridMutation>;
  WidgetCards?: InputMaybe<PageContentWidgetCardsMutation>;
  WidgetBox?: InputMaybe<PageContentWidgetBoxMutation>;
  WidgetCustomContent?: InputMaybe<PageContentWidgetCustomContentMutation>;
  WidgetProjectHeading?: InputMaybe<PageContentWidgetProjectHeadingMutation>;
  WidgetHomeHeading?: InputMaybe<PageContentWidgetHomeHeadingMutation>;
  WidgetSkills?: InputMaybe<PageContentWidgetSkillsMutation>;
  WidgetProjects?: InputMaybe<PageContentWidgetProjectsMutation>;
  WidgetContactForm?: InputMaybe<PageContentWidgetContactFormMutation>;
  WidgetAnchor?: InputMaybe<PageContentWidgetAnchorMutation>;
};

export type PageExtractImageNodeMutation = {
  image?: InputMaybe<Scalars['String']['input']>;
  alt?: InputMaybe<Scalars['String']['input']>;
  credits?: InputMaybe<Scalars['String']['input']>;
};

export type PageExtractMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  imageNode?: InputMaybe<PageExtractImageNodeMutation>;
};

export type PageSeoMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
};

export type PageMutation = {
  type?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  parentPage?: InputMaybe<Scalars['String']['input']>;
  addedAt?: InputMaybe<Scalars['String']['input']>;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  content?: InputMaybe<Array<InputMaybe<PageContentMutation>>>;
  extract?: InputMaybe<PageExtractMutation>;
  seo?: InputMaybe<PageSeoMutation>;
};

export type MenuLinkNodesInternalLinkMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  internalLink?: InputMaybe<Scalars['String']['input']>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  styleInverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MenuLinkNodesExternalLinkMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  styleInverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MenuLinkNodesFileLinkMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  fileLink?: InputMaybe<Scalars['String']['input']>;
  styleInverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MenuLinkNodesMutation = {
  internalLink?: InputMaybe<MenuLinkNodesInternalLinkMutation>;
  externalLink?: InputMaybe<MenuLinkNodesExternalLinkMutation>;
  fileLink?: InputMaybe<MenuLinkNodesFileLinkMutation>;
};

export type MenuMutation = {
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  linkNodes?: InputMaybe<Array<InputMaybe<MenuLinkNodesMutation>>>;
};

export type TagMutation = {
  tag?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
};

export type SettingsGeneralSettingsMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  websiteName?: InputMaybe<Scalars['String']['input']>;
  websiteDescription?: InputMaybe<Scalars['String']['input']>;
  websiteKeywords?: InputMaybe<Scalars['String']['input']>;
  websiteLogo?: InputMaybe<Scalars['String']['input']>;
  websiteIcon?: InputMaybe<Scalars['String']['input']>;
  websiteTop?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsSocialNetworkSettingsPlatformsMutation = {
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsSocialNetworkSettingsMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  websiteShareImage?: InputMaybe<Scalars['String']['input']>;
  platforms?: InputMaybe<Array<InputMaybe<SettingsSocialNetworkSettingsPlatformsMutation>>>;
};

export type SettingsTrackingSettingsMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  googleAnalyticsId?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsContactSettingsContactsLinkNodesInternalLinkMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  internalLink?: InputMaybe<Scalars['String']['input']>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  styleInverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SettingsContactSettingsContactsLinkNodesExternalLinkMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  styleInverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SettingsContactSettingsContactsLinkNodesFileLinkMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  fileLink?: InputMaybe<Scalars['String']['input']>;
  styleInverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SettingsContactSettingsContactsLinkNodesMutation = {
  internalLink?: InputMaybe<SettingsContactSettingsContactsLinkNodesInternalLinkMutation>;
  externalLink?: InputMaybe<SettingsContactSettingsContactsLinkNodesExternalLinkMutation>;
  fileLink?: InputMaybe<SettingsContactSettingsContactsLinkNodesFileLinkMutation>;
};

export type SettingsContactSettingsContactsImageNodeMutation = {
  image?: InputMaybe<Scalars['String']['input']>;
  alt?: InputMaybe<Scalars['String']['input']>;
  credits?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsContactSettingsContactsMutation = {
  name?: InputMaybe<Scalars['String']['input']>;
  linkNodes?: InputMaybe<Array<InputMaybe<SettingsContactSettingsContactsLinkNodesMutation>>>;
  imageNode?: InputMaybe<SettingsContactSettingsContactsImageNodeMutation>;
};

export type SettingsContactSettingsMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  contacts?: InputMaybe<Array<InputMaybe<SettingsContactSettingsContactsMutation>>>;
};

export type SettingsProjectSettingsPaginationLinkNodesInternalLinkMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  internalLink?: InputMaybe<Scalars['String']['input']>;
  anchor?: InputMaybe<Scalars['String']['input']>;
  styleInverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SettingsProjectSettingsPaginationLinkNodesExternalLinkMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  styleInverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SettingsProjectSettingsPaginationLinkNodesFileLinkMutation = {
  label?: InputMaybe<Scalars['String']['input']>;
  fileLink?: InputMaybe<Scalars['String']['input']>;
  styleInverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SettingsProjectSettingsPaginationLinkNodesMutation = {
  internalLink?: InputMaybe<SettingsProjectSettingsPaginationLinkNodesInternalLinkMutation>;
  externalLink?: InputMaybe<SettingsProjectSettingsPaginationLinkNodesExternalLinkMutation>;
  fileLink?: InputMaybe<SettingsProjectSettingsPaginationLinkNodesFileLinkMutation>;
};

export type SettingsProjectSettingsPaginationMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  linkNodes?: InputMaybe<Array<InputMaybe<SettingsProjectSettingsPaginationLinkNodesMutation>>>;
};

export type SettingsProjectSettingsMutation = {
  title?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<SettingsProjectSettingsPaginationMutation>;
};

export type SettingsMutation = {
  generalSettings?: InputMaybe<SettingsGeneralSettingsMutation>;
  socialNetworkSettings?: InputMaybe<SettingsSocialNetworkSettingsMutation>;
  trackingSettings?: InputMaybe<SettingsTrackingSettingsMutation>;
  contactSettings?: InputMaybe<SettingsContactSettingsMutation>;
  projectSettings?: InputMaybe<SettingsProjectSettingsMutation>;
};

export type PagePartsFragment = { __typename: 'Page', type?: string | null, title: string, path: string, addedAt?: string | null, draft?: boolean | null, parentPage?: { __typename: 'Page', type?: string | null, title: string, path: string, addedAt?: string | null, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetHeading', title?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetHeadingImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetParagraphStack', title?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetParagraphStackImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null, specs?: Array<{ __typename: 'PageContentWidgetParagraphStackSpecs', title?: string | null, content?: any | null } | null> | null } | { __typename: 'PageContentWidgetParagraphGrid', title?: string | null, columns?: number | null, grid?: Array<{ __typename: 'PageContentWidgetParagraphGridGrid', title?: string | null, content?: any | null, imageNode?: { __typename: 'PageContentWidgetParagraphGridGridImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetCards', title?: string | null, cardImageOnHover?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, cards?: Array<{ __typename: 'PageContentWidgetCardsCards', title?: string | null, content?: string | null, color?: string | null, imageNode?: { __typename: 'PageContentWidgetCardsCardsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetBox', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBoxLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjectHeading', title?: string | null, client?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, tags?: Array<{ __typename: 'PageContentWidgetProjectHeadingTags' } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetHomeHeading', richTitle?: string | null, richSubtitle?: string | null } | { __typename: 'PageContentWidgetSkills', title?: string | null, subtitle?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, skills?: Array<{ __typename: 'PageContentWidgetSkillsSkills', name?: string | null, description?: any | null, imageNode?: { __typename: 'PageContentWidgetSkillsSkillsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetSkillsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjects', title?: string | null, subtitle?: string | null, intro?: any | null, limit?: number | null, withFilter?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | null> | null, extract?: { __typename: 'PageExtract', title?: string | null, summary?: string | null, imageNode?: { __typename: 'PageExtractImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, content?: Array<{ __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetHeading', title?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetHeadingImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null, internalLink?: { __typename: 'Page', type?: string | null, title: string, path: string, addedAt?: string | null, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetHeading', title?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetHeadingImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetParagraphStack', title?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetParagraphStackImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null, specs?: Array<{ __typename: 'PageContentWidgetParagraphStackSpecs', title?: string | null, content?: any | null } | null> | null } | { __typename: 'PageContentWidgetParagraphGrid', title?: string | null, columns?: number | null, grid?: Array<{ __typename: 'PageContentWidgetParagraphGridGrid', title?: string | null, content?: any | null, imageNode?: { __typename: 'PageContentWidgetParagraphGridGridImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetCards', title?: string | null, cardImageOnHover?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, cards?: Array<{ __typename: 'PageContentWidgetCardsCards', title?: string | null, content?: string | null, color?: string | null, imageNode?: { __typename: 'PageContentWidgetCardsCardsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetBox', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBoxLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjectHeading', title?: string | null, client?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, tags?: Array<{ __typename: 'PageContentWidgetProjectHeadingTags' } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetHomeHeading', richTitle?: string | null, richSubtitle?: string | null } | { __typename: 'PageContentWidgetSkills', title?: string | null, subtitle?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, skills?: Array<{ __typename: 'PageContentWidgetSkillsSkills', name?: string | null, description?: any | null, imageNode?: { __typename: 'PageContentWidgetSkillsSkillsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetSkillsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjects', title?: string | null, subtitle?: string | null, intro?: any | null, limit?: number | null, withFilter?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | null> | null, extract?: { __typename: 'PageExtract', title?: string | null, summary?: string | null, imageNode?: { __typename: 'PageExtractImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | { __typename: 'PageContentWidgetHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetParagraphStack', title?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetParagraphStackImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null, specs?: Array<{ __typename: 'PageContentWidgetParagraphStackSpecs', title?: string | null, content?: any | null } | null> | null } | { __typename: 'PageContentWidgetParagraphGrid', title?: string | null, columns?: number | null, grid?: Array<{ __typename: 'PageContentWidgetParagraphGridGrid', title?: string | null, content?: any | null, imageNode?: { __typename: 'PageContentWidgetParagraphGridGridImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetCards', title?: string | null, cardImageOnHover?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, cards?: Array<{ __typename: 'PageContentWidgetCardsCards', title?: string | null, content?: string | null, color?: string | null, imageNode?: { __typename: 'PageContentWidgetCardsCardsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetBox', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBoxLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null, internalLink?: { __typename: 'Page', type?: string | null, title: string, path: string, addedAt?: string | null, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetHeading', title?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetHeadingImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetParagraphStack', title?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetParagraphStackImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null, specs?: Array<{ __typename: 'PageContentWidgetParagraphStackSpecs', title?: string | null, content?: any | null } | null> | null } | { __typename: 'PageContentWidgetParagraphGrid', title?: string | null, columns?: number | null, grid?: Array<{ __typename: 'PageContentWidgetParagraphGridGrid', title?: string | null, content?: any | null, imageNode?: { __typename: 'PageContentWidgetParagraphGridGridImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetCards', title?: string | null, cardImageOnHover?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, cards?: Array<{ __typename: 'PageContentWidgetCardsCards', title?: string | null, content?: string | null, color?: string | null, imageNode?: { __typename: 'PageContentWidgetCardsCardsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetBox', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBoxLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjectHeading', title?: string | null, client?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, tags?: Array<{ __typename: 'PageContentWidgetProjectHeadingTags' } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetHomeHeading', richTitle?: string | null, richSubtitle?: string | null } | { __typename: 'PageContentWidgetSkills', title?: string | null, subtitle?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, skills?: Array<{ __typename: 'PageContentWidgetSkillsSkills', name?: string | null, description?: any | null, imageNode?: { __typename: 'PageContentWidgetSkillsSkillsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetSkillsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjects', title?: string | null, subtitle?: string | null, intro?: any | null, limit?: number | null, withFilter?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | null> | null, extract?: { __typename: 'PageExtract', title?: string | null, summary?: string | null, imageNode?: { __typename: 'PageExtractImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | { __typename: 'PageContentWidgetBoxLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null, internalLink?: { __typename: 'Page', type?: string | null, title: string, path: string, addedAt?: string | null, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetHeading', title?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetHeadingImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetParagraphStack', title?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetParagraphStackImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null, specs?: Array<{ __typename: 'PageContentWidgetParagraphStackSpecs', title?: string | null, content?: any | null } | null> | null } | { __typename: 'PageContentWidgetParagraphGrid', title?: string | null, columns?: number | null, grid?: Array<{ __typename: 'PageContentWidgetParagraphGridGrid', title?: string | null, content?: any | null, imageNode?: { __typename: 'PageContentWidgetParagraphGridGridImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetCards', title?: string | null, cardImageOnHover?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, cards?: Array<{ __typename: 'PageContentWidgetCardsCards', title?: string | null, content?: string | null, color?: string | null, imageNode?: { __typename: 'PageContentWidgetCardsCardsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetBox', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBoxLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjectHeading', title?: string | null, client?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, tags?: Array<{ __typename: 'PageContentWidgetProjectHeadingTags' } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetHomeHeading', richTitle?: string | null, richSubtitle?: string | null } | { __typename: 'PageContentWidgetSkills', title?: string | null, subtitle?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, skills?: Array<{ __typename: 'PageContentWidgetSkillsSkills', name?: string | null, description?: any | null, imageNode?: { __typename: 'PageContentWidgetSkillsSkillsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetSkillsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjects', title?: string | null, subtitle?: string | null, intro?: any | null, limit?: number | null, withFilter?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | null> | null, extract?: { __typename: 'PageExtract', title?: string | null, summary?: string | null, imageNode?: { __typename: 'PageExtractImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjectHeading', title?: string | null, client?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, tags?: Array<{ __typename: 'PageContentWidgetProjectHeadingTags', tag?: { __typename: 'Tag', tag: string, color?: string | null, order: number, id: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null, internalLink?: { __typename: 'Page', type?: string | null, title: string, path: string, addedAt?: string | null, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetHeading', title?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetHeadingImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetParagraphStack', title?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetParagraphStackImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null, specs?: Array<{ __typename: 'PageContentWidgetParagraphStackSpecs', title?: string | null, content?: any | null } | null> | null } | { __typename: 'PageContentWidgetParagraphGrid', title?: string | null, columns?: number | null, grid?: Array<{ __typename: 'PageContentWidgetParagraphGridGrid', title?: string | null, content?: any | null, imageNode?: { __typename: 'PageContentWidgetParagraphGridGridImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetCards', title?: string | null, cardImageOnHover?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, cards?: Array<{ __typename: 'PageContentWidgetCardsCards', title?: string | null, content?: string | null, color?: string | null, imageNode?: { __typename: 'PageContentWidgetCardsCardsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetBox', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBoxLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjectHeading', title?: string | null, client?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, tags?: Array<{ __typename: 'PageContentWidgetProjectHeadingTags' } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetHomeHeading', richTitle?: string | null, richSubtitle?: string | null } | { __typename: 'PageContentWidgetSkills', title?: string | null, subtitle?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, skills?: Array<{ __typename: 'PageContentWidgetSkillsSkills', name?: string | null, description?: any | null, imageNode?: { __typename: 'PageContentWidgetSkillsSkillsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetSkillsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjects', title?: string | null, subtitle?: string | null, intro?: any | null, limit?: number | null, withFilter?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | null> | null, extract?: { __typename: 'PageExtract', title?: string | null, summary?: string | null, imageNode?: { __typename: 'PageExtractImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetHomeHeading', richTitle?: string | null, richSubtitle?: string | null } | { __typename: 'PageContentWidgetSkills', title?: string | null, subtitle?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, skills?: Array<{ __typename: 'PageContentWidgetSkillsSkills', name?: string | null, description?: any | null, imageNode?: { __typename: 'PageContentWidgetSkillsSkillsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetSkillsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null, internalLink?: { __typename: 'Page', type?: string | null, title: string, path: string, addedAt?: string | null, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetHeading', title?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetHeadingImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetParagraphStack', title?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetParagraphStackImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null, specs?: Array<{ __typename: 'PageContentWidgetParagraphStackSpecs', title?: string | null, content?: any | null } | null> | null } | { __typename: 'PageContentWidgetParagraphGrid', title?: string | null, columns?: number | null, grid?: Array<{ __typename: 'PageContentWidgetParagraphGridGrid', title?: string | null, content?: any | null, imageNode?: { __typename: 'PageContentWidgetParagraphGridGridImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetCards', title?: string | null, cardImageOnHover?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, cards?: Array<{ __typename: 'PageContentWidgetCardsCards', title?: string | null, content?: string | null, color?: string | null, imageNode?: { __typename: 'PageContentWidgetCardsCardsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetBox', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBoxLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjectHeading', title?: string | null, client?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, tags?: Array<{ __typename: 'PageContentWidgetProjectHeadingTags' } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetHomeHeading', richTitle?: string | null, richSubtitle?: string | null } | { __typename: 'PageContentWidgetSkills', title?: string | null, subtitle?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, skills?: Array<{ __typename: 'PageContentWidgetSkillsSkills', name?: string | null, description?: any | null, imageNode?: { __typename: 'PageContentWidgetSkillsSkillsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetSkillsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjects', title?: string | null, subtitle?: string | null, intro?: any | null, limit?: number | null, withFilter?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | null> | null, extract?: { __typename: 'PageExtract', title?: string | null, summary?: string | null, imageNode?: { __typename: 'PageExtractImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | { __typename: 'PageContentWidgetSkillsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjects', title?: string | null, subtitle?: string | null, intro?: any | null, limit?: number | null, withFilter?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null, internalLink?: { __typename: 'Page', type?: string | null, title: string, path: string, addedAt?: string | null, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetHeading', title?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetHeadingImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetParagraphStack', title?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetParagraphStackImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null, specs?: Array<{ __typename: 'PageContentWidgetParagraphStackSpecs', title?: string | null, content?: any | null } | null> | null } | { __typename: 'PageContentWidgetParagraphGrid', title?: string | null, columns?: number | null, grid?: Array<{ __typename: 'PageContentWidgetParagraphGridGrid', title?: string | null, content?: any | null, imageNode?: { __typename: 'PageContentWidgetParagraphGridGridImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetCards', title?: string | null, cardImageOnHover?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, cards?: Array<{ __typename: 'PageContentWidgetCardsCards', title?: string | null, content?: string | null, color?: string | null, imageNode?: { __typename: 'PageContentWidgetCardsCardsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetBox', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBoxLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjectHeading', title?: string | null, client?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, tags?: Array<{ __typename: 'PageContentWidgetProjectHeadingTags' } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetHomeHeading', richTitle?: string | null, richSubtitle?: string | null } | { __typename: 'PageContentWidgetSkills', title?: string | null, subtitle?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, skills?: Array<{ __typename: 'PageContentWidgetSkillsSkills', name?: string | null, description?: any | null, imageNode?: { __typename: 'PageContentWidgetSkillsSkillsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetSkillsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjects', title?: string | null, subtitle?: string | null, intro?: any | null, limit?: number | null, withFilter?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | null> | null, extract?: { __typename: 'PageExtract', title?: string | null, summary?: string | null, imageNode?: { __typename: 'PageExtractImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | { __typename: 'PageContentWidgetProjectsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | null> | null, extract?: { __typename: 'PageExtract', title?: string | null, summary?: string | null, imageNode?: { __typename: 'PageExtractImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null };

export type MenuPartsFragment = { __typename: 'Menu', name: string, position?: string | null, linkNodes?: Array<{ __typename: 'MenuLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null, internalLink?: { __typename: 'Page', type?: string | null, title: string, path: string, addedAt?: string | null, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetHeading', title?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetHeadingImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetParagraphStack', title?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetParagraphStackImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null, specs?: Array<{ __typename: 'PageContentWidgetParagraphStackSpecs', title?: string | null, content?: any | null } | null> | null } | { __typename: 'PageContentWidgetParagraphGrid', title?: string | null, columns?: number | null, grid?: Array<{ __typename: 'PageContentWidgetParagraphGridGrid', title?: string | null, content?: any | null, imageNode?: { __typename: 'PageContentWidgetParagraphGridGridImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetCards', title?: string | null, cardImageOnHover?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, cards?: Array<{ __typename: 'PageContentWidgetCardsCards', title?: string | null, content?: string | null, color?: string | null, imageNode?: { __typename: 'PageContentWidgetCardsCardsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetBox', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBoxLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjectHeading', title?: string | null, client?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, tags?: Array<{ __typename: 'PageContentWidgetProjectHeadingTags' } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetHomeHeading', richTitle?: string | null, richSubtitle?: string | null } | { __typename: 'PageContentWidgetSkills', title?: string | null, subtitle?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, skills?: Array<{ __typename: 'PageContentWidgetSkillsSkills', name?: string | null, description?: any | null, imageNode?: { __typename: 'PageContentWidgetSkillsSkillsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetSkillsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjects', title?: string | null, subtitle?: string | null, intro?: any | null, limit?: number | null, withFilter?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | null> | null, extract?: { __typename: 'PageExtract', title?: string | null, summary?: string | null, imageNode?: { __typename: 'PageExtractImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | { __typename: 'MenuLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'MenuLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null };

export type TagPartsFragment = { __typename: 'Tag', tag: string, color?: string | null, order: number };

type SettingsParts_SettingsGeneralSettings_Fragment = { __typename: 'SettingsGeneralSettings', title: string, websiteName: string, websiteDescription?: string | null, websiteKeywords?: string | null, websiteLogo?: string | null, websiteIcon?: string | null, websiteTop?: string | null };

type SettingsParts_SettingsSocialNetworkSettings_Fragment = { __typename: 'SettingsSocialNetworkSettings', title: string, websiteShareImage?: string | null, platforms?: Array<{ __typename: 'SettingsSocialNetworkSettingsPlatforms', name: string, url: string } | null> | null };

type SettingsParts_SettingsTrackingSettings_Fragment = { __typename: 'SettingsTrackingSettings', title: string, googleAnalyticsId?: string | null };

type SettingsParts_SettingsContactSettings_Fragment = { __typename: 'SettingsContactSettings', title: string, contacts?: Array<{ __typename: 'SettingsContactSettingsContacts', name: string, linkNodes?: Array<{ __typename: 'SettingsContactSettingsContactsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null, internalLink?: { __typename: 'Page', type?: string | null, title: string, path: string, addedAt?: string | null, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetHeading', title?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetHeadingImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetParagraphStack', title?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetParagraphStackImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null, specs?: Array<{ __typename: 'PageContentWidgetParagraphStackSpecs', title?: string | null, content?: any | null } | null> | null } | { __typename: 'PageContentWidgetParagraphGrid', title?: string | null, columns?: number | null, grid?: Array<{ __typename: 'PageContentWidgetParagraphGridGrid', title?: string | null, content?: any | null, imageNode?: { __typename: 'PageContentWidgetParagraphGridGridImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetCards', title?: string | null, cardImageOnHover?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, cards?: Array<{ __typename: 'PageContentWidgetCardsCards', title?: string | null, content?: string | null, color?: string | null, imageNode?: { __typename: 'PageContentWidgetCardsCardsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetBox', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBoxLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjectHeading', title?: string | null, client?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, tags?: Array<{ __typename: 'PageContentWidgetProjectHeadingTags' } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetHomeHeading', richTitle?: string | null, richSubtitle?: string | null } | { __typename: 'PageContentWidgetSkills', title?: string | null, subtitle?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, skills?: Array<{ __typename: 'PageContentWidgetSkillsSkills', name?: string | null, description?: any | null, imageNode?: { __typename: 'PageContentWidgetSkillsSkillsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetSkillsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjects', title?: string | null, subtitle?: string | null, intro?: any | null, limit?: number | null, withFilter?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | null> | null, extract?: { __typename: 'PageExtract', title?: string | null, summary?: string | null, imageNode?: { __typename: 'PageExtractImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | { __typename: 'SettingsContactSettingsContactsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'SettingsContactSettingsContactsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null, imageNode?: { __typename: 'SettingsContactSettingsContactsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null };

type SettingsParts_SettingsProjectSettings_Fragment = { __typename: 'SettingsProjectSettings', title: string, pagination?: { __typename: 'SettingsProjectSettingsPagination', title?: string | null, subtitle?: string | null, limit?: number | null, linkNodes?: Array<{ __typename: 'SettingsProjectSettingsPaginationLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null, internalLink?: { __typename: 'Page', type?: string | null, title: string, path: string, addedAt?: string | null, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetHeading', title?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetHeadingImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetParagraphStack', title?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetParagraphStackImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null, specs?: Array<{ __typename: 'PageContentWidgetParagraphStackSpecs', title?: string | null, content?: any | null } | null> | null } | { __typename: 'PageContentWidgetParagraphGrid', title?: string | null, columns?: number | null, grid?: Array<{ __typename: 'PageContentWidgetParagraphGridGrid', title?: string | null, content?: any | null, imageNode?: { __typename: 'PageContentWidgetParagraphGridGridImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetCards', title?: string | null, cardImageOnHover?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, cards?: Array<{ __typename: 'PageContentWidgetCardsCards', title?: string | null, content?: string | null, color?: string | null, imageNode?: { __typename: 'PageContentWidgetCardsCardsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetBox', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBoxLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjectHeading', title?: string | null, client?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, tags?: Array<{ __typename: 'PageContentWidgetProjectHeadingTags' } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetHomeHeading', richTitle?: string | null, richSubtitle?: string | null } | { __typename: 'PageContentWidgetSkills', title?: string | null, subtitle?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, skills?: Array<{ __typename: 'PageContentWidgetSkillsSkills', name?: string | null, description?: any | null, imageNode?: { __typename: 'PageContentWidgetSkillsSkillsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetSkillsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjects', title?: string | null, subtitle?: string | null, intro?: any | null, limit?: number | null, withFilter?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | null> | null, extract?: { __typename: 'PageExtract', title?: string | null, summary?: string | null, imageNode?: { __typename: 'PageExtractImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | { __typename: 'SettingsProjectSettingsPaginationLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'SettingsProjectSettingsPaginationLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | null };

export type SettingsPartsFragment = SettingsParts_SettingsGeneralSettings_Fragment | SettingsParts_SettingsSocialNetworkSettings_Fragment | SettingsParts_SettingsTrackingSettings_Fragment | SettingsParts_SettingsContactSettings_Fragment | SettingsParts_SettingsProjectSettings_Fragment;

export type PageQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type PageQuery = { __typename?: 'Query', page: { __typename: 'Page', id: string, type?: string | null, title: string, path: string, addedAt?: string | null, draft?: boolean | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, parentPage?: { __typename: 'Page', type?: string | null, title: string, path: string, addedAt?: string | null, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetHeading', title?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetHeadingImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetParagraphStack', title?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetParagraphStackImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null, specs?: Array<{ __typename: 'PageContentWidgetParagraphStackSpecs', title?: string | null, content?: any | null } | null> | null } | { __typename: 'PageContentWidgetParagraphGrid', title?: string | null, columns?: number | null, grid?: Array<{ __typename: 'PageContentWidgetParagraphGridGrid', title?: string | null, content?: any | null, imageNode?: { __typename: 'PageContentWidgetParagraphGridGridImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetCards', title?: string | null, cardImageOnHover?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, cards?: Array<{ __typename: 'PageContentWidgetCardsCards', title?: string | null, content?: string | null, color?: string | null, imageNode?: { __typename: 'PageContentWidgetCardsCardsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetBox', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBoxLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjectHeading', title?: string | null, client?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, tags?: Array<{ __typename: 'PageContentWidgetProjectHeadingTags' } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetHomeHeading', richTitle?: string | null, richSubtitle?: string | null } | { __typename: 'PageContentWidgetSkills', title?: string | null, subtitle?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, skills?: Array<{ __typename: 'PageContentWidgetSkillsSkills', name?: string | null, description?: any | null, imageNode?: { __typename: 'PageContentWidgetSkillsSkillsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetSkillsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjects', title?: string | null, subtitle?: string | null, intro?: any | null, limit?: number | null, withFilter?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | null> | null, extract?: { __typename: 'PageExtract', title?: string | null, summary?: string | null, imageNode?: { __typename: 'PageExtractImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, content?: Array<{ __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetHeading', title?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetHeadingImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null, internalLink?: { __typename: 'Page', type?: string | null, title: string, path: string, addedAt?: string | null, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetHeading', title?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetHeadingImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetParagraphStack', title?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetParagraphStackImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null, specs?: Array<{ __typename: 'PageContentWidgetParagraphStackSpecs', title?: string | null, content?: any | null } | null> | null } | { __typename: 'PageContentWidgetParagraphGrid', title?: string | null, columns?: number | null, grid?: Array<{ __typename: 'PageContentWidgetParagraphGridGrid', title?: string | null, content?: any | null, imageNode?: { __typename: 'PageContentWidgetParagraphGridGridImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetCards', title?: string | null, cardImageOnHover?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, cards?: Array<{ __typename: 'PageContentWidgetCardsCards', title?: string | null, content?: string | null, color?: string | null, imageNode?: { __typename: 'PageContentWidgetCardsCardsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetBox', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBoxLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjectHeading', title?: string | null, client?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, tags?: Array<{ __typename: 'PageContentWidgetProjectHeadingTags' } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetHomeHeading', richTitle?: string | null, richSubtitle?: string | null } | { __typename: 'PageContentWidgetSkills', title?: string | null, subtitle?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, skills?: Array<{ __typename: 'PageContentWidgetSkillsSkills', name?: string | null, description?: any | null, imageNode?: { __typename: 'PageContentWidgetSkillsSkillsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetSkillsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjects', title?: string | null, subtitle?: string | null, intro?: any | null, limit?: number | null, withFilter?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | null> | null, extract?: { __typename: 'PageExtract', title?: string | null, summary?: string | null, imageNode?: { __typename: 'PageExtractImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | { __typename: 'PageContentWidgetHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetParagraphStack', title?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetParagraphStackImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null, specs?: Array<{ __typename: 'PageContentWidgetParagraphStackSpecs', title?: string | null, content?: any | null } | null> | null } | { __typename: 'PageContentWidgetParagraphGrid', title?: string | null, columns?: number | null, grid?: Array<{ __typename: 'PageContentWidgetParagraphGridGrid', title?: string | null, content?: any | null, imageNode?: { __typename: 'PageContentWidgetParagraphGridGridImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetCards', title?: string | null, cardImageOnHover?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, cards?: Array<{ __typename: 'PageContentWidgetCardsCards', title?: string | null, content?: string | null, color?: string | null, imageNode?: { __typename: 'PageContentWidgetCardsCardsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetBox', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBoxLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null, internalLink?: { __typename: 'Page', type?: string | null, title: string, path: string, addedAt?: string | null, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetHeading', title?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetHeadingImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetParagraphStack', title?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetParagraphStackImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null, specs?: Array<{ __typename: 'PageContentWidgetParagraphStackSpecs', title?: string | null, content?: any | null } | null> | null } | { __typename: 'PageContentWidgetParagraphGrid', title?: string | null, columns?: number | null, grid?: Array<{ __typename: 'PageContentWidgetParagraphGridGrid', title?: string | null, content?: any | null, imageNode?: { __typename: 'PageContentWidgetParagraphGridGridImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetCards', title?: string | null, cardImageOnHover?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, cards?: Array<{ __typename: 'PageContentWidgetCardsCards', title?: string | null, content?: string | null, color?: string | null, imageNode?: { __typename: 'PageContentWidgetCardsCardsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetBox', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBoxLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjectHeading', title?: string | null, client?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, tags?: Array<{ __typename: 'PageContentWidgetProjectHeadingTags' } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetHomeHeading', richTitle?: string | null, richSubtitle?: string | null } | { __typename: 'PageContentWidgetSkills', title?: string | null, subtitle?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, skills?: Array<{ __typename: 'PageContentWidgetSkillsSkills', name?: string | null, description?: any | null, imageNode?: { __typename: 'PageContentWidgetSkillsSkillsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetSkillsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjects', title?: string | null, subtitle?: string | null, intro?: any | null, limit?: number | null, withFilter?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | null> | null, extract?: { __typename: 'PageExtract', title?: string | null, summary?: string | null, imageNode?: { __typename: 'PageExtractImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | { __typename: 'PageContentWidgetBoxLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null, internalLink?: { __typename: 'Page', type?: string | null, title: string, path: string, addedAt?: string | null, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetHeading', title?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetHeadingImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetParagraphStack', title?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetParagraphStackImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null, specs?: Array<{ __typename: 'PageContentWidgetParagraphStackSpecs', title?: string | null, content?: any | null } | null> | null } | { __typename: 'PageContentWidgetParagraphGrid', title?: string | null, columns?: number | null, grid?: Array<{ __typename: 'PageContentWidgetParagraphGridGrid', title?: string | null, content?: any | null, imageNode?: { __typename: 'PageContentWidgetParagraphGridGridImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetCards', title?: string | null, cardImageOnHover?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, cards?: Array<{ __typename: 'PageContentWidgetCardsCards', title?: string | null, content?: string | null, color?: string | null, imageNode?: { __typename: 'PageContentWidgetCardsCardsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetBox', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBoxLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjectHeading', title?: string | null, client?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, tags?: Array<{ __typename: 'PageContentWidgetProjectHeadingTags' } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetHomeHeading', richTitle?: string | null, richSubtitle?: string | null } | { __typename: 'PageContentWidgetSkills', title?: string | null, subtitle?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, skills?: Array<{ __typename: 'PageContentWidgetSkillsSkills', name?: string | null, description?: any | null, imageNode?: { __typename: 'PageContentWidgetSkillsSkillsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetSkillsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjects', title?: string | null, subtitle?: string | null, intro?: any | null, limit?: number | null, withFilter?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | null> | null, extract?: { __typename: 'PageExtract', title?: string | null, summary?: string | null, imageNode?: { __typename: 'PageExtractImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjectHeading', title?: string | null, client?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, tags?: Array<{ __typename: 'PageContentWidgetProjectHeadingTags', tag?: { __typename: 'Tag', tag: string, color?: string | null, order: number, id: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null, internalLink?: { __typename: 'Page', type?: string | null, title: string, path: string, addedAt?: string | null, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetHeading', title?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetHeadingImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetParagraphStack', title?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetParagraphStackImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null, specs?: Array<{ __typename: 'PageContentWidgetParagraphStackSpecs', title?: string | null, content?: any | null } | null> | null } | { __typename: 'PageContentWidgetParagraphGrid', title?: string | null, columns?: number | null, grid?: Array<{ __typename: 'PageContentWidgetParagraphGridGrid', title?: string | null, content?: any | null, imageNode?: { __typename: 'PageContentWidgetParagraphGridGridImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetCards', title?: string | null, cardImageOnHover?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, cards?: Array<{ __typename: 'PageContentWidgetCardsCards', title?: string | null, content?: string | null, color?: string | null, imageNode?: { __typename: 'PageContentWidgetCardsCardsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetBox', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBoxLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjectHeading', title?: string | null, client?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, tags?: Array<{ __typename: 'PageContentWidgetProjectHeadingTags' } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetHomeHeading', richTitle?: string | null, richSubtitle?: string | null } | { __typename: 'PageContentWidgetSkills', title?: string | null, subtitle?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, skills?: Array<{ __typename: 'PageContentWidgetSkillsSkills', name?: string | null, description?: any | null, imageNode?: { __typename: 'PageContentWidgetSkillsSkillsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetSkillsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjects', title?: string | null, subtitle?: string | null, intro?: any | null, limit?: number | null, withFilter?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | null> | null, extract?: { __typename: 'PageExtract', title?: string | null, summary?: string | null, imageNode?: { __typename: 'PageExtractImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetHomeHeading', richTitle?: string | null, richSubtitle?: string | null } | { __typename: 'PageContentWidgetSkills', title?: string | null, subtitle?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, skills?: Array<{ __typename: 'PageContentWidgetSkillsSkills', name?: string | null, description?: any | null, imageNode?: { __typename: 'PageContentWidgetSkillsSkillsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetSkillsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null, internalLink?: { __typename: 'Page', type?: string | null, title: string, path: string, addedAt?: string | null, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetHeading', title?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetHeadingImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetParagraphStack', title?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetParagraphStackImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null, specs?: Array<{ __typename: 'PageContentWidgetParagraphStackSpecs', title?: string | null, content?: any | null } | null> | null } | { __typename: 'PageContentWidgetParagraphGrid', title?: string | null, columns?: number | null, grid?: Array<{ __typename: 'PageContentWidgetParagraphGridGrid', title?: string | null, content?: any | null, imageNode?: { __typename: 'PageContentWidgetParagraphGridGridImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetCards', title?: string | null, cardImageOnHover?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, cards?: Array<{ __typename: 'PageContentWidgetCardsCards', title?: string | null, content?: string | null, color?: string | null, imageNode?: { __typename: 'PageContentWidgetCardsCardsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetBox', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBoxLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjectHeading', title?: string | null, client?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, tags?: Array<{ __typename: 'PageContentWidgetProjectHeadingTags' } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetHomeHeading', richTitle?: string | null, richSubtitle?: string | null } | { __typename: 'PageContentWidgetSkills', title?: string | null, subtitle?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, skills?: Array<{ __typename: 'PageContentWidgetSkillsSkills', name?: string | null, description?: any | null, imageNode?: { __typename: 'PageContentWidgetSkillsSkillsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetSkillsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjects', title?: string | null, subtitle?: string | null, intro?: any | null, limit?: number | null, withFilter?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | null> | null, extract?: { __typename: 'PageExtract', title?: string | null, summary?: string | null, imageNode?: { __typename: 'PageExtractImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | { __typename: 'PageContentWidgetSkillsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjects', title?: string | null, subtitle?: string | null, intro?: any | null, limit?: number | null, withFilter?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null, internalLink?: { __typename: 'Page', type?: string | null, title: string, path: string, addedAt?: string | null, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetHeading', title?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetHeadingImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetParagraphStack', title?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetParagraphStackImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null, specs?: Array<{ __typename: 'PageContentWidgetParagraphStackSpecs', title?: string | null, content?: any | null } | null> | null } | { __typename: 'PageContentWidgetParagraphGrid', title?: string | null, columns?: number | null, grid?: Array<{ __typename: 'PageContentWidgetParagraphGridGrid', title?: string | null, content?: any | null, imageNode?: { __typename: 'PageContentWidgetParagraphGridGridImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetCards', title?: string | null, cardImageOnHover?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, cards?: Array<{ __typename: 'PageContentWidgetCardsCards', title?: string | null, content?: string | null, color?: string | null, imageNode?: { __typename: 'PageContentWidgetCardsCardsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetBox', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBoxLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjectHeading', title?: string | null, client?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, tags?: Array<{ __typename: 'PageContentWidgetProjectHeadingTags' } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetHomeHeading', richTitle?: string | null, richSubtitle?: string | null } | { __typename: 'PageContentWidgetSkills', title?: string | null, subtitle?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, skills?: Array<{ __typename: 'PageContentWidgetSkillsSkills', name?: string | null, description?: any | null, imageNode?: { __typename: 'PageContentWidgetSkillsSkillsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetSkillsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjects', title?: string | null, subtitle?: string | null, intro?: any | null, limit?: number | null, withFilter?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | null> | null, extract?: { __typename: 'PageExtract', title?: string | null, summary?: string | null, imageNode?: { __typename: 'PageExtractImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | { __typename: 'PageContentWidgetProjectsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | null> | null, extract?: { __typename: 'PageExtract', title?: string | null, summary?: string | null, imageNode?: { __typename: 'PageExtractImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null } };

export type PageConnectionQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PageFilter>;
}>;


export type PageConnectionQuery = { __typename?: 'Query', pageConnection: { __typename?: 'PageConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor: string, endCursor: string }, edges?: Array<{ __typename?: 'PageConnectionEdges', cursor: string, node?: { __typename: 'Page', id: string, type?: string | null, title: string, path: string, addedAt?: string | null, draft?: boolean | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, parentPage?: { __typename: 'Page', type?: string | null, title: string, path: string, addedAt?: string | null, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetHeading', title?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetHeadingImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetParagraphStack', title?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetParagraphStackImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null, specs?: Array<{ __typename: 'PageContentWidgetParagraphStackSpecs', title?: string | null, content?: any | null } | null> | null } | { __typename: 'PageContentWidgetParagraphGrid', title?: string | null, columns?: number | null, grid?: Array<{ __typename: 'PageContentWidgetParagraphGridGrid', title?: string | null, content?: any | null, imageNode?: { __typename: 'PageContentWidgetParagraphGridGridImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetCards', title?: string | null, cardImageOnHover?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, cards?: Array<{ __typename: 'PageContentWidgetCardsCards', title?: string | null, content?: string | null, color?: string | null, imageNode?: { __typename: 'PageContentWidgetCardsCardsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetBox', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBoxLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjectHeading', title?: string | null, client?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, tags?: Array<{ __typename: 'PageContentWidgetProjectHeadingTags' } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetHomeHeading', richTitle?: string | null, richSubtitle?: string | null } | { __typename: 'PageContentWidgetSkills', title?: string | null, subtitle?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, skills?: Array<{ __typename: 'PageContentWidgetSkillsSkills', name?: string | null, description?: any | null, imageNode?: { __typename: 'PageContentWidgetSkillsSkillsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetSkillsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjects', title?: string | null, subtitle?: string | null, intro?: any | null, limit?: number | null, withFilter?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | null> | null, extract?: { __typename: 'PageExtract', title?: string | null, summary?: string | null, imageNode?: { __typename: 'PageExtractImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null, content?: Array<{ __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetHeading', title?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetHeadingImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null, internalLink?: { __typename: 'Page', type?: string | null, title: string, path: string, addedAt?: string | null, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetHeading', title?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetHeadingImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetParagraphStack', title?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetParagraphStackImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null, specs?: Array<{ __typename: 'PageContentWidgetParagraphStackSpecs', title?: string | null, content?: any | null } | null> | null } | { __typename: 'PageContentWidgetParagraphGrid', title?: string | null, columns?: number | null, grid?: Array<{ __typename: 'PageContentWidgetParagraphGridGrid', title?: string | null, content?: any | null, imageNode?: { __typename: 'PageContentWidgetParagraphGridGridImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetCards', title?: string | null, cardImageOnHover?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, cards?: Array<{ __typename: 'PageContentWidgetCardsCards', title?: string | null, content?: string | null, color?: string | null, imageNode?: { __typename: 'PageContentWidgetCardsCardsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetBox', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBoxLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjectHeading', title?: string | null, client?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, tags?: Array<{ __typename: 'PageContentWidgetProjectHeadingTags' } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetHomeHeading', richTitle?: string | null, richSubtitle?: string | null } | { __typename: 'PageContentWidgetSkills', title?: string | null, subtitle?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, skills?: Array<{ __typename: 'PageContentWidgetSkillsSkills', name?: string | null, description?: any | null, imageNode?: { __typename: 'PageContentWidgetSkillsSkillsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetSkillsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjects', title?: string | null, subtitle?: string | null, intro?: any | null, limit?: number | null, withFilter?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | null> | null, extract?: { __typename: 'PageExtract', title?: string | null, summary?: string | null, imageNode?: { __typename: 'PageExtractImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | { __typename: 'PageContentWidgetHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetParagraphStack', title?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetParagraphStackImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null, specs?: Array<{ __typename: 'PageContentWidgetParagraphStackSpecs', title?: string | null, content?: any | null } | null> | null } | { __typename: 'PageContentWidgetParagraphGrid', title?: string | null, columns?: number | null, grid?: Array<{ __typename: 'PageContentWidgetParagraphGridGrid', title?: string | null, content?: any | null, imageNode?: { __typename: 'PageContentWidgetParagraphGridGridImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetCards', title?: string | null, cardImageOnHover?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, cards?: Array<{ __typename: 'PageContentWidgetCardsCards', title?: string | null, content?: string | null, color?: string | null, imageNode?: { __typename: 'PageContentWidgetCardsCardsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetBox', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBoxLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null, internalLink?: { __typename: 'Page', type?: string | null, title: string, path: string, addedAt?: string | null, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetHeading', title?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetHeadingImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetParagraphStack', title?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetParagraphStackImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null, specs?: Array<{ __typename: 'PageContentWidgetParagraphStackSpecs', title?: string | null, content?: any | null } | null> | null } | { __typename: 'PageContentWidgetParagraphGrid', title?: string | null, columns?: number | null, grid?: Array<{ __typename: 'PageContentWidgetParagraphGridGrid', title?: string | null, content?: any | null, imageNode?: { __typename: 'PageContentWidgetParagraphGridGridImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetCards', title?: string | null, cardImageOnHover?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, cards?: Array<{ __typename: 'PageContentWidgetCardsCards', title?: string | null, content?: string | null, color?: string | null, imageNode?: { __typename: 'PageContentWidgetCardsCardsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetBox', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBoxLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjectHeading', title?: string | null, client?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, tags?: Array<{ __typename: 'PageContentWidgetProjectHeadingTags' } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetHomeHeading', richTitle?: string | null, richSubtitle?: string | null } | { __typename: 'PageContentWidgetSkills', title?: string | null, subtitle?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, skills?: Array<{ __typename: 'PageContentWidgetSkillsSkills', name?: string | null, description?: any | null, imageNode?: { __typename: 'PageContentWidgetSkillsSkillsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetSkillsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjects', title?: string | null, subtitle?: string | null, intro?: any | null, limit?: number | null, withFilter?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | null> | null, extract?: { __typename: 'PageExtract', title?: string | null, summary?: string | null, imageNode?: { __typename: 'PageExtractImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | { __typename: 'PageContentWidgetBoxLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null, internalLink?: { __typename: 'Page', type?: string | null, title: string, path: string, addedAt?: string | null, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetHeading', title?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetHeadingImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetParagraphStack', title?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetParagraphStackImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null, specs?: Array<{ __typename: 'PageContentWidgetParagraphStackSpecs', title?: string | null, content?: any | null } | null> | null } | { __typename: 'PageContentWidgetParagraphGrid', title?: string | null, columns?: number | null, grid?: Array<{ __typename: 'PageContentWidgetParagraphGridGrid', title?: string | null, content?: any | null, imageNode?: { __typename: 'PageContentWidgetParagraphGridGridImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetCards', title?: string | null, cardImageOnHover?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, cards?: Array<{ __typename: 'PageContentWidgetCardsCards', title?: string | null, content?: string | null, color?: string | null, imageNode?: { __typename: 'PageContentWidgetCardsCardsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetBox', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBoxLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjectHeading', title?: string | null, client?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, tags?: Array<{ __typename: 'PageContentWidgetProjectHeadingTags' } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetHomeHeading', richTitle?: string | null, richSubtitle?: string | null } | { __typename: 'PageContentWidgetSkills', title?: string | null, subtitle?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, skills?: Array<{ __typename: 'PageContentWidgetSkillsSkills', name?: string | null, description?: any | null, imageNode?: { __typename: 'PageContentWidgetSkillsSkillsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetSkillsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjects', title?: string | null, subtitle?: string | null, intro?: any | null, limit?: number | null, withFilter?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | null> | null, extract?: { __typename: 'PageExtract', title?: string | null, summary?: string | null, imageNode?: { __typename: 'PageExtractImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjectHeading', title?: string | null, client?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, tags?: Array<{ __typename: 'PageContentWidgetProjectHeadingTags', tag?: { __typename: 'Tag', tag: string, color?: string | null, order: number, id: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null, internalLink?: { __typename: 'Page', type?: string | null, title: string, path: string, addedAt?: string | null, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetHeading', title?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetHeadingImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetParagraphStack', title?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetParagraphStackImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null, specs?: Array<{ __typename: 'PageContentWidgetParagraphStackSpecs', title?: string | null, content?: any | null } | null> | null } | { __typename: 'PageContentWidgetParagraphGrid', title?: string | null, columns?: number | null, grid?: Array<{ __typename: 'PageContentWidgetParagraphGridGrid', title?: string | null, content?: any | null, imageNode?: { __typename: 'PageContentWidgetParagraphGridGridImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetCards', title?: string | null, cardImageOnHover?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, cards?: Array<{ __typename: 'PageContentWidgetCardsCards', title?: string | null, content?: string | null, color?: string | null, imageNode?: { __typename: 'PageContentWidgetCardsCardsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetBox', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBoxLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjectHeading', title?: string | null, client?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, tags?: Array<{ __typename: 'PageContentWidgetProjectHeadingTags' } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetHomeHeading', richTitle?: string | null, richSubtitle?: string | null } | { __typename: 'PageContentWidgetSkills', title?: string | null, subtitle?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, skills?: Array<{ __typename: 'PageContentWidgetSkillsSkills', name?: string | null, description?: any | null, imageNode?: { __typename: 'PageContentWidgetSkillsSkillsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetSkillsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjects', title?: string | null, subtitle?: string | null, intro?: any | null, limit?: number | null, withFilter?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | null> | null, extract?: { __typename: 'PageExtract', title?: string | null, summary?: string | null, imageNode?: { __typename: 'PageExtractImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetHomeHeading', richTitle?: string | null, richSubtitle?: string | null } | { __typename: 'PageContentWidgetSkills', title?: string | null, subtitle?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, skills?: Array<{ __typename: 'PageContentWidgetSkillsSkills', name?: string | null, description?: any | null, imageNode?: { __typename: 'PageContentWidgetSkillsSkillsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetSkillsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null, internalLink?: { __typename: 'Page', type?: string | null, title: string, path: string, addedAt?: string | null, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetHeading', title?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetHeadingImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetParagraphStack', title?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetParagraphStackImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null, specs?: Array<{ __typename: 'PageContentWidgetParagraphStackSpecs', title?: string | null, content?: any | null } | null> | null } | { __typename: 'PageContentWidgetParagraphGrid', title?: string | null, columns?: number | null, grid?: Array<{ __typename: 'PageContentWidgetParagraphGridGrid', title?: string | null, content?: any | null, imageNode?: { __typename: 'PageContentWidgetParagraphGridGridImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetCards', title?: string | null, cardImageOnHover?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, cards?: Array<{ __typename: 'PageContentWidgetCardsCards', title?: string | null, content?: string | null, color?: string | null, imageNode?: { __typename: 'PageContentWidgetCardsCardsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetBox', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBoxLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjectHeading', title?: string | null, client?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, tags?: Array<{ __typename: 'PageContentWidgetProjectHeadingTags' } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetHomeHeading', richTitle?: string | null, richSubtitle?: string | null } | { __typename: 'PageContentWidgetSkills', title?: string | null, subtitle?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, skills?: Array<{ __typename: 'PageContentWidgetSkillsSkills', name?: string | null, description?: any | null, imageNode?: { __typename: 'PageContentWidgetSkillsSkillsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetSkillsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjects', title?: string | null, subtitle?: string | null, intro?: any | null, limit?: number | null, withFilter?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | null> | null, extract?: { __typename: 'PageExtract', title?: string | null, summary?: string | null, imageNode?: { __typename: 'PageExtractImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | { __typename: 'PageContentWidgetSkillsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjects', title?: string | null, subtitle?: string | null, intro?: any | null, limit?: number | null, withFilter?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null, internalLink?: { __typename: 'Page', type?: string | null, title: string, path: string, addedAt?: string | null, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetHeading', title?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetHeadingImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetParagraphStack', title?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetParagraphStackImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null, specs?: Array<{ __typename: 'PageContentWidgetParagraphStackSpecs', title?: string | null, content?: any | null } | null> | null } | { __typename: 'PageContentWidgetParagraphGrid', title?: string | null, columns?: number | null, grid?: Array<{ __typename: 'PageContentWidgetParagraphGridGrid', title?: string | null, content?: any | null, imageNode?: { __typename: 'PageContentWidgetParagraphGridGridImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetCards', title?: string | null, cardImageOnHover?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, cards?: Array<{ __typename: 'PageContentWidgetCardsCards', title?: string | null, content?: string | null, color?: string | null, imageNode?: { __typename: 'PageContentWidgetCardsCardsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetBox', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBoxLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjectHeading', title?: string | null, client?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, tags?: Array<{ __typename: 'PageContentWidgetProjectHeadingTags' } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetHomeHeading', richTitle?: string | null, richSubtitle?: string | null } | { __typename: 'PageContentWidgetSkills', title?: string | null, subtitle?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, skills?: Array<{ __typename: 'PageContentWidgetSkillsSkills', name?: string | null, description?: any | null, imageNode?: { __typename: 'PageContentWidgetSkillsSkillsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetSkillsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjects', title?: string | null, subtitle?: string | null, intro?: any | null, limit?: number | null, withFilter?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | null> | null, extract?: { __typename: 'PageExtract', title?: string | null, summary?: string | null, imageNode?: { __typename: 'PageExtractImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | { __typename: 'PageContentWidgetProjectsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | null> | null, extract?: { __typename: 'PageExtract', title?: string | null, summary?: string | null, imageNode?: { __typename: 'PageExtractImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null } | null } | null> | null } };

export type MenuQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type MenuQuery = { __typename?: 'Query', menu: { __typename: 'Menu', id: string, name: string, position?: string | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, linkNodes?: Array<{ __typename: 'MenuLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null, internalLink?: { __typename: 'Page', type?: string | null, title: string, path: string, addedAt?: string | null, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetHeading', title?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetHeadingImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetParagraphStack', title?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetParagraphStackImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null, specs?: Array<{ __typename: 'PageContentWidgetParagraphStackSpecs', title?: string | null, content?: any | null } | null> | null } | { __typename: 'PageContentWidgetParagraphGrid', title?: string | null, columns?: number | null, grid?: Array<{ __typename: 'PageContentWidgetParagraphGridGrid', title?: string | null, content?: any | null, imageNode?: { __typename: 'PageContentWidgetParagraphGridGridImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetCards', title?: string | null, cardImageOnHover?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, cards?: Array<{ __typename: 'PageContentWidgetCardsCards', title?: string | null, content?: string | null, color?: string | null, imageNode?: { __typename: 'PageContentWidgetCardsCardsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetBox', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBoxLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjectHeading', title?: string | null, client?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, tags?: Array<{ __typename: 'PageContentWidgetProjectHeadingTags' } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetHomeHeading', richTitle?: string | null, richSubtitle?: string | null } | { __typename: 'PageContentWidgetSkills', title?: string | null, subtitle?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, skills?: Array<{ __typename: 'PageContentWidgetSkillsSkills', name?: string | null, description?: any | null, imageNode?: { __typename: 'PageContentWidgetSkillsSkillsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetSkillsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjects', title?: string | null, subtitle?: string | null, intro?: any | null, limit?: number | null, withFilter?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | null> | null, extract?: { __typename: 'PageExtract', title?: string | null, summary?: string | null, imageNode?: { __typename: 'PageExtractImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | { __typename: 'MenuLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'MenuLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } };

export type MenuConnectionQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<MenuFilter>;
}>;


export type MenuConnectionQuery = { __typename?: 'Query', menuConnection: { __typename?: 'MenuConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor: string, endCursor: string }, edges?: Array<{ __typename?: 'MenuConnectionEdges', cursor: string, node?: { __typename: 'Menu', id: string, name: string, position?: string | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, linkNodes?: Array<{ __typename: 'MenuLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null, internalLink?: { __typename: 'Page', type?: string | null, title: string, path: string, addedAt?: string | null, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetHeading', title?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetHeadingImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetParagraphStack', title?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetParagraphStackImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null, specs?: Array<{ __typename: 'PageContentWidgetParagraphStackSpecs', title?: string | null, content?: any | null } | null> | null } | { __typename: 'PageContentWidgetParagraphGrid', title?: string | null, columns?: number | null, grid?: Array<{ __typename: 'PageContentWidgetParagraphGridGrid', title?: string | null, content?: any | null, imageNode?: { __typename: 'PageContentWidgetParagraphGridGridImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetCards', title?: string | null, cardImageOnHover?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, cards?: Array<{ __typename: 'PageContentWidgetCardsCards', title?: string | null, content?: string | null, color?: string | null, imageNode?: { __typename: 'PageContentWidgetCardsCardsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetBox', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBoxLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjectHeading', title?: string | null, client?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, tags?: Array<{ __typename: 'PageContentWidgetProjectHeadingTags' } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetHomeHeading', richTitle?: string | null, richSubtitle?: string | null } | { __typename: 'PageContentWidgetSkills', title?: string | null, subtitle?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, skills?: Array<{ __typename: 'PageContentWidgetSkillsSkills', name?: string | null, description?: any | null, imageNode?: { __typename: 'PageContentWidgetSkillsSkillsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetSkillsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjects', title?: string | null, subtitle?: string | null, intro?: any | null, limit?: number | null, withFilter?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | null> | null, extract?: { __typename: 'PageExtract', title?: string | null, summary?: string | null, imageNode?: { __typename: 'PageExtractImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | { __typename: 'MenuLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'MenuLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | null } | null> | null } };

export type TagQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type TagQuery = { __typename?: 'Query', tag: { __typename: 'Tag', id: string, tag: string, color?: string | null, order: number, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } };

export type TagConnectionQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TagFilter>;
}>;


export type TagConnectionQuery = { __typename?: 'Query', tagConnection: { __typename?: 'TagConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor: string, endCursor: string }, edges?: Array<{ __typename?: 'TagConnectionEdges', cursor: string, node?: { __typename: 'Tag', id: string, tag: string, color?: string | null, order: number, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null } };

export type SettingsQueryVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type SettingsQuery = { __typename?: 'Query', settings: { __typename: 'SettingsGeneralSettings', id: string, title: string, websiteName: string, websiteDescription?: string | null, websiteKeywords?: string | null, websiteLogo?: string | null, websiteIcon?: string | null, websiteTop?: string | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | { __typename: 'SettingsSocialNetworkSettings', id: string, title: string, websiteShareImage?: string | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, platforms?: Array<{ __typename: 'SettingsSocialNetworkSettingsPlatforms', name: string, url: string } | null> | null } | { __typename: 'SettingsTrackingSettings', id: string, title: string, googleAnalyticsId?: string | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | { __typename: 'SettingsContactSettings', id: string, title: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, contacts?: Array<{ __typename: 'SettingsContactSettingsContacts', name: string, linkNodes?: Array<{ __typename: 'SettingsContactSettingsContactsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null, internalLink?: { __typename: 'Page', type?: string | null, title: string, path: string, addedAt?: string | null, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetHeading', title?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetHeadingImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetParagraphStack', title?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetParagraphStackImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null, specs?: Array<{ __typename: 'PageContentWidgetParagraphStackSpecs', title?: string | null, content?: any | null } | null> | null } | { __typename: 'PageContentWidgetParagraphGrid', title?: string | null, columns?: number | null, grid?: Array<{ __typename: 'PageContentWidgetParagraphGridGrid', title?: string | null, content?: any | null, imageNode?: { __typename: 'PageContentWidgetParagraphGridGridImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetCards', title?: string | null, cardImageOnHover?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, cards?: Array<{ __typename: 'PageContentWidgetCardsCards', title?: string | null, content?: string | null, color?: string | null, imageNode?: { __typename: 'PageContentWidgetCardsCardsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetBox', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBoxLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjectHeading', title?: string | null, client?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, tags?: Array<{ __typename: 'PageContentWidgetProjectHeadingTags' } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetHomeHeading', richTitle?: string | null, richSubtitle?: string | null } | { __typename: 'PageContentWidgetSkills', title?: string | null, subtitle?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, skills?: Array<{ __typename: 'PageContentWidgetSkillsSkills', name?: string | null, description?: any | null, imageNode?: { __typename: 'PageContentWidgetSkillsSkillsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetSkillsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjects', title?: string | null, subtitle?: string | null, intro?: any | null, limit?: number | null, withFilter?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | null> | null, extract?: { __typename: 'PageExtract', title?: string | null, summary?: string | null, imageNode?: { __typename: 'PageExtractImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | { __typename: 'SettingsContactSettingsContactsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'SettingsContactSettingsContactsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null, imageNode?: { __typename: 'SettingsContactSettingsContactsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'SettingsProjectSettings', id: string, title: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, pagination?: { __typename: 'SettingsProjectSettingsPagination', title?: string | null, subtitle?: string | null, limit?: number | null, linkNodes?: Array<{ __typename: 'SettingsProjectSettingsPaginationLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null, internalLink?: { __typename: 'Page', type?: string | null, title: string, path: string, addedAt?: string | null, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetHeading', title?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetHeadingImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetParagraphStack', title?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetParagraphStackImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null, specs?: Array<{ __typename: 'PageContentWidgetParagraphStackSpecs', title?: string | null, content?: any | null } | null> | null } | { __typename: 'PageContentWidgetParagraphGrid', title?: string | null, columns?: number | null, grid?: Array<{ __typename: 'PageContentWidgetParagraphGridGrid', title?: string | null, content?: any | null, imageNode?: { __typename: 'PageContentWidgetParagraphGridGridImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetCards', title?: string | null, cardImageOnHover?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, cards?: Array<{ __typename: 'PageContentWidgetCardsCards', title?: string | null, content?: string | null, color?: string | null, imageNode?: { __typename: 'PageContentWidgetCardsCardsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetBox', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBoxLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjectHeading', title?: string | null, client?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, tags?: Array<{ __typename: 'PageContentWidgetProjectHeadingTags' } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetHomeHeading', richTitle?: string | null, richSubtitle?: string | null } | { __typename: 'PageContentWidgetSkills', title?: string | null, subtitle?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, skills?: Array<{ __typename: 'PageContentWidgetSkillsSkills', name?: string | null, description?: any | null, imageNode?: { __typename: 'PageContentWidgetSkillsSkillsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetSkillsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjects', title?: string | null, subtitle?: string | null, intro?: any | null, limit?: number | null, withFilter?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | null> | null, extract?: { __typename: 'PageExtract', title?: string | null, summary?: string | null, imageNode?: { __typename: 'PageExtractImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | { __typename: 'SettingsProjectSettingsPaginationLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'SettingsProjectSettingsPaginationLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | null } };

export type SettingsConnectionQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SettingsFilter>;
}>;


export type SettingsConnectionQuery = { __typename?: 'Query', settingsConnection: { __typename?: 'SettingsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor: string, endCursor: string }, edges?: Array<{ __typename?: 'SettingsConnectionEdges', cursor: string, node?: { __typename: 'SettingsGeneralSettings', id: string, title: string, websiteName: string, websiteDescription?: string | null, websiteKeywords?: string | null, websiteLogo?: string | null, websiteIcon?: string | null, websiteTop?: string | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | { __typename: 'SettingsSocialNetworkSettings', id: string, title: string, websiteShareImage?: string | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, platforms?: Array<{ __typename: 'SettingsSocialNetworkSettingsPlatforms', name: string, url: string } | null> | null } | { __typename: 'SettingsTrackingSettings', id: string, title: string, googleAnalyticsId?: string | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | { __typename: 'SettingsContactSettings', id: string, title: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, contacts?: Array<{ __typename: 'SettingsContactSettingsContacts', name: string, linkNodes?: Array<{ __typename: 'SettingsContactSettingsContactsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null, internalLink?: { __typename: 'Page', type?: string | null, title: string, path: string, addedAt?: string | null, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetHeading', title?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetHeadingImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetParagraphStack', title?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetParagraphStackImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null, specs?: Array<{ __typename: 'PageContentWidgetParagraphStackSpecs', title?: string | null, content?: any | null } | null> | null } | { __typename: 'PageContentWidgetParagraphGrid', title?: string | null, columns?: number | null, grid?: Array<{ __typename: 'PageContentWidgetParagraphGridGrid', title?: string | null, content?: any | null, imageNode?: { __typename: 'PageContentWidgetParagraphGridGridImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetCards', title?: string | null, cardImageOnHover?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, cards?: Array<{ __typename: 'PageContentWidgetCardsCards', title?: string | null, content?: string | null, color?: string | null, imageNode?: { __typename: 'PageContentWidgetCardsCardsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetBox', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBoxLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjectHeading', title?: string | null, client?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, tags?: Array<{ __typename: 'PageContentWidgetProjectHeadingTags' } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetHomeHeading', richTitle?: string | null, richSubtitle?: string | null } | { __typename: 'PageContentWidgetSkills', title?: string | null, subtitle?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, skills?: Array<{ __typename: 'PageContentWidgetSkillsSkills', name?: string | null, description?: any | null, imageNode?: { __typename: 'PageContentWidgetSkillsSkillsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetSkillsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjects', title?: string | null, subtitle?: string | null, intro?: any | null, limit?: number | null, withFilter?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | null> | null, extract?: { __typename: 'PageExtract', title?: string | null, summary?: string | null, imageNode?: { __typename: 'PageExtractImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | { __typename: 'SettingsContactSettingsContactsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'SettingsContactSettingsContactsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null, imageNode?: { __typename: 'SettingsContactSettingsContactsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'SettingsProjectSettings', id: string, title: string, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, pagination?: { __typename: 'SettingsProjectSettingsPagination', title?: string | null, subtitle?: string | null, limit?: number | null, linkNodes?: Array<{ __typename: 'SettingsProjectSettingsPaginationLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null, internalLink?: { __typename: 'Page', type?: string | null, title: string, path: string, addedAt?: string | null, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetHeading', title?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetHeadingImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetParagraphStack', title?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, imageNode?: { __typename: 'PageContentWidgetParagraphStackImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null, specs?: Array<{ __typename: 'PageContentWidgetParagraphStackSpecs', title?: string | null, content?: any | null } | null> | null } | { __typename: 'PageContentWidgetParagraphGrid', title?: string | null, columns?: number | null, grid?: Array<{ __typename: 'PageContentWidgetParagraphGridGrid', title?: string | null, content?: any | null, imageNode?: { __typename: 'PageContentWidgetParagraphGridGridImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetCards', title?: string | null, cardImageOnHover?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, cards?: Array<{ __typename: 'PageContentWidgetCardsCards', title?: string | null, content?: string | null, color?: string | null, imageNode?: { __typename: 'PageContentWidgetCardsCardsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null } | { __typename: 'PageContentWidgetBox', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBoxLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetBoxLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjectHeading', title?: string | null, client?: string | null, content?: any | null, contentWithColumns?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, tags?: Array<{ __typename: 'PageContentWidgetProjectHeadingTags' } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectHeadingLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectHeadingLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetHomeHeading', richTitle?: string | null, richSubtitle?: string | null } | { __typename: 'PageContentWidgetSkills', title?: string | null, subtitle?: string | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, skills?: Array<{ __typename: 'PageContentWidgetSkillsSkills', name?: string | null, description?: any | null, imageNode?: { __typename: 'PageContentWidgetSkillsSkillsImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetSkillsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetSkillsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetProjects', title?: string | null, subtitle?: string | null, intro?: any | null, limit?: number | null, withFilter?: boolean | null, withBackgroundImage?: string | null, withBackgroundGradient?: boolean | null, linkNodes?: Array<{ __typename: 'PageContentWidgetProjectsLinkNodesInternalLink', label?: string | null, anchor?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'PageContentWidgetProjectsLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | null> | null, extract?: { __typename: 'PageExtract', title?: string | null, summary?: string | null, imageNode?: { __typename: 'PageExtractImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | { __typename: 'SettingsProjectSettingsPaginationLinkNodesExternalLink', label?: string | null, url?: string | null, styleInverse?: boolean | null } | { __typename: 'SettingsProjectSettingsPaginationLinkNodesFileLink', label?: string | null, fileLink?: string | null, styleInverse?: boolean | null } | null> | null } | null } | null } | null> | null } };

export const PagePartsFragmentDoc = gql`
    fragment PageParts on Page {
  __typename
  type
  title
  path
  parentPage {
    ... on Page {
      __typename
      type
      title
      path
      addedAt
      draft
      content {
        __typename
        ... on PageContentWidgetBannerImage {
          image
          alt
          credits
          aspectRatio
        }
        ... on PageContentWidgetHeading {
          title
          imageNode {
            __typename
            image
            alt
            credits
          }
          content
          contentWithColumns
          linkNodes {
            __typename
            ... on PageContentWidgetHeadingLinkNodesInternalLink {
              label
              anchor
              styleInverse
            }
            ... on PageContentWidgetHeadingLinkNodesExternalLink {
              label
              url
              styleInverse
            }
            ... on PageContentWidgetHeadingLinkNodesFileLink {
              label
              fileLink
              styleInverse
            }
          }
          withBackgroundImage
          withBackgroundGradient
        }
        ... on PageContentWidgetImageGrid {
          grid {
            __typename
            imageNodes {
              __typename
              image
              alt
              credits
              aspectRatio
            }
          }
          withBackgroundImage
          withBackgroundGradient
        }
        ... on PageContentWidgetParagraphStack {
          title
          imageNode {
            __typename
            image
            alt
            credits
            aspectRatio
          }
          specs {
            __typename
            title
            content
          }
          withBackgroundImage
          withBackgroundGradient
        }
        ... on PageContentWidgetParagraphGrid {
          title
          grid {
            __typename
            title
            content
            imageNode {
              __typename
              image
              alt
              credits
            }
          }
          columns
        }
        ... on PageContentWidgetCards {
          title
          cards {
            __typename
            title
            content
            color
            imageNode {
              __typename
              image
              alt
              credits
            }
          }
          cardImageOnHover
          withBackgroundImage
          withBackgroundGradient
        }
        ... on PageContentWidgetBox {
          title
          content
          linkNodes {
            __typename
            ... on PageContentWidgetBoxLinkNodesInternalLink {
              label
              anchor
              styleInverse
            }
            ... on PageContentWidgetBoxLinkNodesExternalLink {
              label
              url
              styleInverse
            }
            ... on PageContentWidgetBoxLinkNodesFileLink {
              label
              fileLink
              styleInverse
            }
          }
        }
        ... on PageContentWidgetCustomContent {
          title
          content
          linkNodes {
            __typename
            ... on PageContentWidgetCustomContentLinkNodesInternalLink {
              label
              anchor
              styleInverse
            }
            ... on PageContentWidgetCustomContentLinkNodesExternalLink {
              label
              url
              styleInverse
            }
            ... on PageContentWidgetCustomContentLinkNodesFileLink {
              label
              fileLink
              styleInverse
            }
          }
        }
        ... on PageContentWidgetProjectHeading {
          title
          client
          tags {
            __typename
          }
          content
          contentWithColumns
          linkNodes {
            __typename
            ... on PageContentWidgetProjectHeadingLinkNodesInternalLink {
              label
              anchor
              styleInverse
            }
            ... on PageContentWidgetProjectHeadingLinkNodesExternalLink {
              label
              url
              styleInverse
            }
            ... on PageContentWidgetProjectHeadingLinkNodesFileLink {
              label
              fileLink
              styleInverse
            }
          }
          withBackgroundImage
          withBackgroundGradient
        }
        ... on PageContentWidgetHomeHeading {
          richTitle
          richSubtitle
        }
        ... on PageContentWidgetSkills {
          title
          subtitle
          skills {
            __typename
            name
            description
            imageNode {
              __typename
              image
              alt
              credits
            }
          }
          linkNodes {
            __typename
            ... on PageContentWidgetSkillsLinkNodesInternalLink {
              label
              anchor
              styleInverse
            }
            ... on PageContentWidgetSkillsLinkNodesExternalLink {
              label
              url
              styleInverse
            }
            ... on PageContentWidgetSkillsLinkNodesFileLink {
              label
              fileLink
              styleInverse
            }
          }
          withBackgroundImage
          withBackgroundGradient
        }
        ... on PageContentWidgetProjects {
          title
          subtitle
          intro
          limit
          withFilter
          linkNodes {
            __typename
            ... on PageContentWidgetProjectsLinkNodesInternalLink {
              label
              anchor
              styleInverse
            }
            ... on PageContentWidgetProjectsLinkNodesExternalLink {
              label
              url
              styleInverse
            }
            ... on PageContentWidgetProjectsLinkNodesFileLink {
              label
              fileLink
              styleInverse
            }
          }
          withBackgroundImage
          withBackgroundGradient
        }
        ... on PageContentWidgetContactForm {
          title
          content
          name
          sendButton
          resendButton
          successMessage
          errorMessage
        }
        ... on PageContentWidgetAnchor {
          name
        }
      }
      extract {
        __typename
        title
        summary
        imageNode {
          __typename
          image
          alt
          credits
        }
      }
      seo {
        __typename
        title
        description
        keywords
        image
      }
    }
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
  }
  addedAt
  draft
  content {
    __typename
    ... on PageContentWidgetBannerImage {
      image
      alt
      credits
      aspectRatio
    }
    ... on PageContentWidgetHeading {
      title
      imageNode {
        __typename
        image
        alt
        credits
      }
      content
      contentWithColumns
      linkNodes {
        __typename
        ... on PageContentWidgetHeadingLinkNodesInternalLink {
          label
          internalLink {
            ... on Page {
              __typename
              type
              title
              path
              addedAt
              draft
              content {
                __typename
                ... on PageContentWidgetBannerImage {
                  image
                  alt
                  credits
                  aspectRatio
                }
                ... on PageContentWidgetHeading {
                  title
                  imageNode {
                    __typename
                    image
                    alt
                    credits
                  }
                  content
                  contentWithColumns
                  linkNodes {
                    __typename
                    ... on PageContentWidgetHeadingLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetHeadingLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetHeadingLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetImageGrid {
                  grid {
                    __typename
                    imageNodes {
                      __typename
                      image
                      alt
                      credits
                      aspectRatio
                    }
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetParagraphStack {
                  title
                  imageNode {
                    __typename
                    image
                    alt
                    credits
                    aspectRatio
                  }
                  specs {
                    __typename
                    title
                    content
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetParagraphGrid {
                  title
                  grid {
                    __typename
                    title
                    content
                    imageNode {
                      __typename
                      image
                      alt
                      credits
                    }
                  }
                  columns
                }
                ... on PageContentWidgetCards {
                  title
                  cards {
                    __typename
                    title
                    content
                    color
                    imageNode {
                      __typename
                      image
                      alt
                      credits
                    }
                  }
                  cardImageOnHover
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetBox {
                  title
                  content
                  linkNodes {
                    __typename
                    ... on PageContentWidgetBoxLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetBoxLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetBoxLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                }
                ... on PageContentWidgetCustomContent {
                  title
                  content
                  linkNodes {
                    __typename
                    ... on PageContentWidgetCustomContentLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetCustomContentLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetCustomContentLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                }
                ... on PageContentWidgetProjectHeading {
                  title
                  client
                  tags {
                    __typename
                  }
                  content
                  contentWithColumns
                  linkNodes {
                    __typename
                    ... on PageContentWidgetProjectHeadingLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetProjectHeadingLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetProjectHeadingLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetHomeHeading {
                  richTitle
                  richSubtitle
                }
                ... on PageContentWidgetSkills {
                  title
                  subtitle
                  skills {
                    __typename
                    name
                    description
                    imageNode {
                      __typename
                      image
                      alt
                      credits
                    }
                  }
                  linkNodes {
                    __typename
                    ... on PageContentWidgetSkillsLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetSkillsLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetSkillsLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetProjects {
                  title
                  subtitle
                  intro
                  limit
                  withFilter
                  linkNodes {
                    __typename
                    ... on PageContentWidgetProjectsLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetProjectsLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetProjectsLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetContactForm {
                  title
                  content
                  name
                  sendButton
                  resendButton
                  successMessage
                  errorMessage
                }
                ... on PageContentWidgetAnchor {
                  name
                }
              }
              extract {
                __typename
                title
                summary
                imageNode {
                  __typename
                  image
                  alt
                  credits
                }
              }
              seo {
                __typename
                title
                description
                keywords
                image
              }
            }
            ... on Document {
              _sys {
                filename
                basename
                breadcrumbs
                path
                relativePath
                extension
              }
              id
            }
          }
          anchor
          styleInverse
        }
        ... on PageContentWidgetHeadingLinkNodesExternalLink {
          label
          url
          styleInverse
        }
        ... on PageContentWidgetHeadingLinkNodesFileLink {
          label
          fileLink
          styleInverse
        }
      }
      withBackgroundImage
      withBackgroundGradient
    }
    ... on PageContentWidgetImageGrid {
      grid {
        __typename
        imageNodes {
          __typename
          image
          alt
          credits
          aspectRatio
        }
      }
      withBackgroundImage
      withBackgroundGradient
    }
    ... on PageContentWidgetParagraphStack {
      title
      imageNode {
        __typename
        image
        alt
        credits
        aspectRatio
      }
      specs {
        __typename
        title
        content
      }
      withBackgroundImage
      withBackgroundGradient
    }
    ... on PageContentWidgetParagraphGrid {
      title
      grid {
        __typename
        title
        content
        imageNode {
          __typename
          image
          alt
          credits
        }
      }
      columns
    }
    ... on PageContentWidgetCards {
      title
      cards {
        __typename
        title
        content
        color
        imageNode {
          __typename
          image
          alt
          credits
        }
      }
      cardImageOnHover
      withBackgroundImage
      withBackgroundGradient
    }
    ... on PageContentWidgetBox {
      title
      content
      linkNodes {
        __typename
        ... on PageContentWidgetBoxLinkNodesInternalLink {
          label
          internalLink {
            ... on Page {
              __typename
              type
              title
              path
              addedAt
              draft
              content {
                __typename
                ... on PageContentWidgetBannerImage {
                  image
                  alt
                  credits
                  aspectRatio
                }
                ... on PageContentWidgetHeading {
                  title
                  imageNode {
                    __typename
                    image
                    alt
                    credits
                  }
                  content
                  contentWithColumns
                  linkNodes {
                    __typename
                    ... on PageContentWidgetHeadingLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetHeadingLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetHeadingLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetImageGrid {
                  grid {
                    __typename
                    imageNodes {
                      __typename
                      image
                      alt
                      credits
                      aspectRatio
                    }
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetParagraphStack {
                  title
                  imageNode {
                    __typename
                    image
                    alt
                    credits
                    aspectRatio
                  }
                  specs {
                    __typename
                    title
                    content
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetParagraphGrid {
                  title
                  grid {
                    __typename
                    title
                    content
                    imageNode {
                      __typename
                      image
                      alt
                      credits
                    }
                  }
                  columns
                }
                ... on PageContentWidgetCards {
                  title
                  cards {
                    __typename
                    title
                    content
                    color
                    imageNode {
                      __typename
                      image
                      alt
                      credits
                    }
                  }
                  cardImageOnHover
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetBox {
                  title
                  content
                  linkNodes {
                    __typename
                    ... on PageContentWidgetBoxLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetBoxLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetBoxLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                }
                ... on PageContentWidgetCustomContent {
                  title
                  content
                  linkNodes {
                    __typename
                    ... on PageContentWidgetCustomContentLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetCustomContentLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetCustomContentLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                }
                ... on PageContentWidgetProjectHeading {
                  title
                  client
                  tags {
                    __typename
                  }
                  content
                  contentWithColumns
                  linkNodes {
                    __typename
                    ... on PageContentWidgetProjectHeadingLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetProjectHeadingLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetProjectHeadingLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetHomeHeading {
                  richTitle
                  richSubtitle
                }
                ... on PageContentWidgetSkills {
                  title
                  subtitle
                  skills {
                    __typename
                    name
                    description
                    imageNode {
                      __typename
                      image
                      alt
                      credits
                    }
                  }
                  linkNodes {
                    __typename
                    ... on PageContentWidgetSkillsLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetSkillsLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetSkillsLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetProjects {
                  title
                  subtitle
                  intro
                  limit
                  withFilter
                  linkNodes {
                    __typename
                    ... on PageContentWidgetProjectsLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetProjectsLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetProjectsLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetContactForm {
                  title
                  content
                  name
                  sendButton
                  resendButton
                  successMessage
                  errorMessage
                }
                ... on PageContentWidgetAnchor {
                  name
                }
              }
              extract {
                __typename
                title
                summary
                imageNode {
                  __typename
                  image
                  alt
                  credits
                }
              }
              seo {
                __typename
                title
                description
                keywords
                image
              }
            }
            ... on Document {
              _sys {
                filename
                basename
                breadcrumbs
                path
                relativePath
                extension
              }
              id
            }
          }
          anchor
          styleInverse
        }
        ... on PageContentWidgetBoxLinkNodesExternalLink {
          label
          url
          styleInverse
        }
        ... on PageContentWidgetBoxLinkNodesFileLink {
          label
          fileLink
          styleInverse
        }
      }
    }
    ... on PageContentWidgetCustomContent {
      title
      content
      linkNodes {
        __typename
        ... on PageContentWidgetCustomContentLinkNodesInternalLink {
          label
          internalLink {
            ... on Page {
              __typename
              type
              title
              path
              addedAt
              draft
              content {
                __typename
                ... on PageContentWidgetBannerImage {
                  image
                  alt
                  credits
                  aspectRatio
                }
                ... on PageContentWidgetHeading {
                  title
                  imageNode {
                    __typename
                    image
                    alt
                    credits
                  }
                  content
                  contentWithColumns
                  linkNodes {
                    __typename
                    ... on PageContentWidgetHeadingLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetHeadingLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetHeadingLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetImageGrid {
                  grid {
                    __typename
                    imageNodes {
                      __typename
                      image
                      alt
                      credits
                      aspectRatio
                    }
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetParagraphStack {
                  title
                  imageNode {
                    __typename
                    image
                    alt
                    credits
                    aspectRatio
                  }
                  specs {
                    __typename
                    title
                    content
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetParagraphGrid {
                  title
                  grid {
                    __typename
                    title
                    content
                    imageNode {
                      __typename
                      image
                      alt
                      credits
                    }
                  }
                  columns
                }
                ... on PageContentWidgetCards {
                  title
                  cards {
                    __typename
                    title
                    content
                    color
                    imageNode {
                      __typename
                      image
                      alt
                      credits
                    }
                  }
                  cardImageOnHover
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetBox {
                  title
                  content
                  linkNodes {
                    __typename
                    ... on PageContentWidgetBoxLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetBoxLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetBoxLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                }
                ... on PageContentWidgetCustomContent {
                  title
                  content
                  linkNodes {
                    __typename
                    ... on PageContentWidgetCustomContentLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetCustomContentLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetCustomContentLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                }
                ... on PageContentWidgetProjectHeading {
                  title
                  client
                  tags {
                    __typename
                  }
                  content
                  contentWithColumns
                  linkNodes {
                    __typename
                    ... on PageContentWidgetProjectHeadingLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetProjectHeadingLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetProjectHeadingLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetHomeHeading {
                  richTitle
                  richSubtitle
                }
                ... on PageContentWidgetSkills {
                  title
                  subtitle
                  skills {
                    __typename
                    name
                    description
                    imageNode {
                      __typename
                      image
                      alt
                      credits
                    }
                  }
                  linkNodes {
                    __typename
                    ... on PageContentWidgetSkillsLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetSkillsLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetSkillsLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetProjects {
                  title
                  subtitle
                  intro
                  limit
                  withFilter
                  linkNodes {
                    __typename
                    ... on PageContentWidgetProjectsLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetProjectsLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetProjectsLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetContactForm {
                  title
                  content
                  name
                  sendButton
                  resendButton
                  successMessage
                  errorMessage
                }
                ... on PageContentWidgetAnchor {
                  name
                }
              }
              extract {
                __typename
                title
                summary
                imageNode {
                  __typename
                  image
                  alt
                  credits
                }
              }
              seo {
                __typename
                title
                description
                keywords
                image
              }
            }
            ... on Document {
              _sys {
                filename
                basename
                breadcrumbs
                path
                relativePath
                extension
              }
              id
            }
          }
          anchor
          styleInverse
        }
        ... on PageContentWidgetCustomContentLinkNodesExternalLink {
          label
          url
          styleInverse
        }
        ... on PageContentWidgetCustomContentLinkNodesFileLink {
          label
          fileLink
          styleInverse
        }
      }
    }
    ... on PageContentWidgetProjectHeading {
      title
      client
      tags {
        __typename
        tag {
          ... on Tag {
            __typename
            tag
            color
            order
          }
          ... on Document {
            _sys {
              filename
              basename
              breadcrumbs
              path
              relativePath
              extension
            }
            id
          }
        }
      }
      content
      contentWithColumns
      linkNodes {
        __typename
        ... on PageContentWidgetProjectHeadingLinkNodesInternalLink {
          label
          internalLink {
            ... on Page {
              __typename
              type
              title
              path
              addedAt
              draft
              content {
                __typename
                ... on PageContentWidgetBannerImage {
                  image
                  alt
                  credits
                  aspectRatio
                }
                ... on PageContentWidgetHeading {
                  title
                  imageNode {
                    __typename
                    image
                    alt
                    credits
                  }
                  content
                  contentWithColumns
                  linkNodes {
                    __typename
                    ... on PageContentWidgetHeadingLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetHeadingLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetHeadingLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetImageGrid {
                  grid {
                    __typename
                    imageNodes {
                      __typename
                      image
                      alt
                      credits
                      aspectRatio
                    }
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetParagraphStack {
                  title
                  imageNode {
                    __typename
                    image
                    alt
                    credits
                    aspectRatio
                  }
                  specs {
                    __typename
                    title
                    content
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetParagraphGrid {
                  title
                  grid {
                    __typename
                    title
                    content
                    imageNode {
                      __typename
                      image
                      alt
                      credits
                    }
                  }
                  columns
                }
                ... on PageContentWidgetCards {
                  title
                  cards {
                    __typename
                    title
                    content
                    color
                    imageNode {
                      __typename
                      image
                      alt
                      credits
                    }
                  }
                  cardImageOnHover
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetBox {
                  title
                  content
                  linkNodes {
                    __typename
                    ... on PageContentWidgetBoxLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetBoxLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetBoxLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                }
                ... on PageContentWidgetCustomContent {
                  title
                  content
                  linkNodes {
                    __typename
                    ... on PageContentWidgetCustomContentLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetCustomContentLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetCustomContentLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                }
                ... on PageContentWidgetProjectHeading {
                  title
                  client
                  tags {
                    __typename
                  }
                  content
                  contentWithColumns
                  linkNodes {
                    __typename
                    ... on PageContentWidgetProjectHeadingLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetProjectHeadingLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetProjectHeadingLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetHomeHeading {
                  richTitle
                  richSubtitle
                }
                ... on PageContentWidgetSkills {
                  title
                  subtitle
                  skills {
                    __typename
                    name
                    description
                    imageNode {
                      __typename
                      image
                      alt
                      credits
                    }
                  }
                  linkNodes {
                    __typename
                    ... on PageContentWidgetSkillsLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetSkillsLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetSkillsLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetProjects {
                  title
                  subtitle
                  intro
                  limit
                  withFilter
                  linkNodes {
                    __typename
                    ... on PageContentWidgetProjectsLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetProjectsLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetProjectsLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetContactForm {
                  title
                  content
                  name
                  sendButton
                  resendButton
                  successMessage
                  errorMessage
                }
                ... on PageContentWidgetAnchor {
                  name
                }
              }
              extract {
                __typename
                title
                summary
                imageNode {
                  __typename
                  image
                  alt
                  credits
                }
              }
              seo {
                __typename
                title
                description
                keywords
                image
              }
            }
            ... on Document {
              _sys {
                filename
                basename
                breadcrumbs
                path
                relativePath
                extension
              }
              id
            }
          }
          anchor
          styleInverse
        }
        ... on PageContentWidgetProjectHeadingLinkNodesExternalLink {
          label
          url
          styleInverse
        }
        ... on PageContentWidgetProjectHeadingLinkNodesFileLink {
          label
          fileLink
          styleInverse
        }
      }
      withBackgroundImage
      withBackgroundGradient
    }
    ... on PageContentWidgetHomeHeading {
      richTitle
      richSubtitle
    }
    ... on PageContentWidgetSkills {
      title
      subtitle
      skills {
        __typename
        name
        description
        imageNode {
          __typename
          image
          alt
          credits
        }
      }
      linkNodes {
        __typename
        ... on PageContentWidgetSkillsLinkNodesInternalLink {
          label
          internalLink {
            ... on Page {
              __typename
              type
              title
              path
              addedAt
              draft
              content {
                __typename
                ... on PageContentWidgetBannerImage {
                  image
                  alt
                  credits
                  aspectRatio
                }
                ... on PageContentWidgetHeading {
                  title
                  imageNode {
                    __typename
                    image
                    alt
                    credits
                  }
                  content
                  contentWithColumns
                  linkNodes {
                    __typename
                    ... on PageContentWidgetHeadingLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetHeadingLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetHeadingLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetImageGrid {
                  grid {
                    __typename
                    imageNodes {
                      __typename
                      image
                      alt
                      credits
                      aspectRatio
                    }
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetParagraphStack {
                  title
                  imageNode {
                    __typename
                    image
                    alt
                    credits
                    aspectRatio
                  }
                  specs {
                    __typename
                    title
                    content
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetParagraphGrid {
                  title
                  grid {
                    __typename
                    title
                    content
                    imageNode {
                      __typename
                      image
                      alt
                      credits
                    }
                  }
                  columns
                }
                ... on PageContentWidgetCards {
                  title
                  cards {
                    __typename
                    title
                    content
                    color
                    imageNode {
                      __typename
                      image
                      alt
                      credits
                    }
                  }
                  cardImageOnHover
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetBox {
                  title
                  content
                  linkNodes {
                    __typename
                    ... on PageContentWidgetBoxLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetBoxLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetBoxLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                }
                ... on PageContentWidgetCustomContent {
                  title
                  content
                  linkNodes {
                    __typename
                    ... on PageContentWidgetCustomContentLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetCustomContentLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetCustomContentLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                }
                ... on PageContentWidgetProjectHeading {
                  title
                  client
                  tags {
                    __typename
                  }
                  content
                  contentWithColumns
                  linkNodes {
                    __typename
                    ... on PageContentWidgetProjectHeadingLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetProjectHeadingLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetProjectHeadingLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetHomeHeading {
                  richTitle
                  richSubtitle
                }
                ... on PageContentWidgetSkills {
                  title
                  subtitle
                  skills {
                    __typename
                    name
                    description
                    imageNode {
                      __typename
                      image
                      alt
                      credits
                    }
                  }
                  linkNodes {
                    __typename
                    ... on PageContentWidgetSkillsLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetSkillsLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetSkillsLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetProjects {
                  title
                  subtitle
                  intro
                  limit
                  withFilter
                  linkNodes {
                    __typename
                    ... on PageContentWidgetProjectsLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetProjectsLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetProjectsLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetContactForm {
                  title
                  content
                  name
                  sendButton
                  resendButton
                  successMessage
                  errorMessage
                }
                ... on PageContentWidgetAnchor {
                  name
                }
              }
              extract {
                __typename
                title
                summary
                imageNode {
                  __typename
                  image
                  alt
                  credits
                }
              }
              seo {
                __typename
                title
                description
                keywords
                image
              }
            }
            ... on Document {
              _sys {
                filename
                basename
                breadcrumbs
                path
                relativePath
                extension
              }
              id
            }
          }
          anchor
          styleInverse
        }
        ... on PageContentWidgetSkillsLinkNodesExternalLink {
          label
          url
          styleInverse
        }
        ... on PageContentWidgetSkillsLinkNodesFileLink {
          label
          fileLink
          styleInverse
        }
      }
      withBackgroundImage
      withBackgroundGradient
    }
    ... on PageContentWidgetProjects {
      title
      subtitle
      intro
      limit
      withFilter
      linkNodes {
        __typename
        ... on PageContentWidgetProjectsLinkNodesInternalLink {
          label
          internalLink {
            ... on Page {
              __typename
              type
              title
              path
              addedAt
              draft
              content {
                __typename
                ... on PageContentWidgetBannerImage {
                  image
                  alt
                  credits
                  aspectRatio
                }
                ... on PageContentWidgetHeading {
                  title
                  imageNode {
                    __typename
                    image
                    alt
                    credits
                  }
                  content
                  contentWithColumns
                  linkNodes {
                    __typename
                    ... on PageContentWidgetHeadingLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetHeadingLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetHeadingLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetImageGrid {
                  grid {
                    __typename
                    imageNodes {
                      __typename
                      image
                      alt
                      credits
                      aspectRatio
                    }
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetParagraphStack {
                  title
                  imageNode {
                    __typename
                    image
                    alt
                    credits
                    aspectRatio
                  }
                  specs {
                    __typename
                    title
                    content
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetParagraphGrid {
                  title
                  grid {
                    __typename
                    title
                    content
                    imageNode {
                      __typename
                      image
                      alt
                      credits
                    }
                  }
                  columns
                }
                ... on PageContentWidgetCards {
                  title
                  cards {
                    __typename
                    title
                    content
                    color
                    imageNode {
                      __typename
                      image
                      alt
                      credits
                    }
                  }
                  cardImageOnHover
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetBox {
                  title
                  content
                  linkNodes {
                    __typename
                    ... on PageContentWidgetBoxLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetBoxLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetBoxLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                }
                ... on PageContentWidgetCustomContent {
                  title
                  content
                  linkNodes {
                    __typename
                    ... on PageContentWidgetCustomContentLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetCustomContentLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetCustomContentLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                }
                ... on PageContentWidgetProjectHeading {
                  title
                  client
                  tags {
                    __typename
                  }
                  content
                  contentWithColumns
                  linkNodes {
                    __typename
                    ... on PageContentWidgetProjectHeadingLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetProjectHeadingLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetProjectHeadingLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetHomeHeading {
                  richTitle
                  richSubtitle
                }
                ... on PageContentWidgetSkills {
                  title
                  subtitle
                  skills {
                    __typename
                    name
                    description
                    imageNode {
                      __typename
                      image
                      alt
                      credits
                    }
                  }
                  linkNodes {
                    __typename
                    ... on PageContentWidgetSkillsLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetSkillsLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetSkillsLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetProjects {
                  title
                  subtitle
                  intro
                  limit
                  withFilter
                  linkNodes {
                    __typename
                    ... on PageContentWidgetProjectsLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetProjectsLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetProjectsLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetContactForm {
                  title
                  content
                  name
                  sendButton
                  resendButton
                  successMessage
                  errorMessage
                }
                ... on PageContentWidgetAnchor {
                  name
                }
              }
              extract {
                __typename
                title
                summary
                imageNode {
                  __typename
                  image
                  alt
                  credits
                }
              }
              seo {
                __typename
                title
                description
                keywords
                image
              }
            }
            ... on Document {
              _sys {
                filename
                basename
                breadcrumbs
                path
                relativePath
                extension
              }
              id
            }
          }
          anchor
          styleInverse
        }
        ... on PageContentWidgetProjectsLinkNodesExternalLink {
          label
          url
          styleInverse
        }
        ... on PageContentWidgetProjectsLinkNodesFileLink {
          label
          fileLink
          styleInverse
        }
      }
      withBackgroundImage
      withBackgroundGradient
    }
    ... on PageContentWidgetContactForm {
      title
      content
      name
      sendButton
      resendButton
      successMessage
      errorMessage
    }
    ... on PageContentWidgetAnchor {
      name
    }
  }
  extract {
    __typename
    title
    summary
    imageNode {
      __typename
      image
      alt
      credits
    }
  }
  seo {
    __typename
    title
    description
    keywords
    image
  }
}
    `;
export const MenuPartsFragmentDoc = gql`
    fragment MenuParts on Menu {
  __typename
  name
  position
  linkNodes {
    __typename
    ... on MenuLinkNodesInternalLink {
      label
      internalLink {
        ... on Page {
          __typename
          type
          title
          path
          addedAt
          draft
          content {
            __typename
            ... on PageContentWidgetBannerImage {
              image
              alt
              credits
              aspectRatio
            }
            ... on PageContentWidgetHeading {
              title
              imageNode {
                __typename
                image
                alt
                credits
              }
              content
              contentWithColumns
              linkNodes {
                __typename
                ... on PageContentWidgetHeadingLinkNodesInternalLink {
                  label
                  anchor
                  styleInverse
                }
                ... on PageContentWidgetHeadingLinkNodesExternalLink {
                  label
                  url
                  styleInverse
                }
                ... on PageContentWidgetHeadingLinkNodesFileLink {
                  label
                  fileLink
                  styleInverse
                }
              }
              withBackgroundImage
              withBackgroundGradient
            }
            ... on PageContentWidgetImageGrid {
              grid {
                __typename
                imageNodes {
                  __typename
                  image
                  alt
                  credits
                  aspectRatio
                }
              }
              withBackgroundImage
              withBackgroundGradient
            }
            ... on PageContentWidgetParagraphStack {
              title
              imageNode {
                __typename
                image
                alt
                credits
                aspectRatio
              }
              specs {
                __typename
                title
                content
              }
              withBackgroundImage
              withBackgroundGradient
            }
            ... on PageContentWidgetParagraphGrid {
              title
              grid {
                __typename
                title
                content
                imageNode {
                  __typename
                  image
                  alt
                  credits
                }
              }
              columns
            }
            ... on PageContentWidgetCards {
              title
              cards {
                __typename
                title
                content
                color
                imageNode {
                  __typename
                  image
                  alt
                  credits
                }
              }
              cardImageOnHover
              withBackgroundImage
              withBackgroundGradient
            }
            ... on PageContentWidgetBox {
              title
              content
              linkNodes {
                __typename
                ... on PageContentWidgetBoxLinkNodesInternalLink {
                  label
                  anchor
                  styleInverse
                }
                ... on PageContentWidgetBoxLinkNodesExternalLink {
                  label
                  url
                  styleInverse
                }
                ... on PageContentWidgetBoxLinkNodesFileLink {
                  label
                  fileLink
                  styleInverse
                }
              }
            }
            ... on PageContentWidgetCustomContent {
              title
              content
              linkNodes {
                __typename
                ... on PageContentWidgetCustomContentLinkNodesInternalLink {
                  label
                  anchor
                  styleInverse
                }
                ... on PageContentWidgetCustomContentLinkNodesExternalLink {
                  label
                  url
                  styleInverse
                }
                ... on PageContentWidgetCustomContentLinkNodesFileLink {
                  label
                  fileLink
                  styleInverse
                }
              }
            }
            ... on PageContentWidgetProjectHeading {
              title
              client
              tags {
                __typename
              }
              content
              contentWithColumns
              linkNodes {
                __typename
                ... on PageContentWidgetProjectHeadingLinkNodesInternalLink {
                  label
                  anchor
                  styleInverse
                }
                ... on PageContentWidgetProjectHeadingLinkNodesExternalLink {
                  label
                  url
                  styleInverse
                }
                ... on PageContentWidgetProjectHeadingLinkNodesFileLink {
                  label
                  fileLink
                  styleInverse
                }
              }
              withBackgroundImage
              withBackgroundGradient
            }
            ... on PageContentWidgetHomeHeading {
              richTitle
              richSubtitle
            }
            ... on PageContentWidgetSkills {
              title
              subtitle
              skills {
                __typename
                name
                description
                imageNode {
                  __typename
                  image
                  alt
                  credits
                }
              }
              linkNodes {
                __typename
                ... on PageContentWidgetSkillsLinkNodesInternalLink {
                  label
                  anchor
                  styleInverse
                }
                ... on PageContentWidgetSkillsLinkNodesExternalLink {
                  label
                  url
                  styleInverse
                }
                ... on PageContentWidgetSkillsLinkNodesFileLink {
                  label
                  fileLink
                  styleInverse
                }
              }
              withBackgroundImage
              withBackgroundGradient
            }
            ... on PageContentWidgetProjects {
              title
              subtitle
              intro
              limit
              withFilter
              linkNodes {
                __typename
                ... on PageContentWidgetProjectsLinkNodesInternalLink {
                  label
                  anchor
                  styleInverse
                }
                ... on PageContentWidgetProjectsLinkNodesExternalLink {
                  label
                  url
                  styleInverse
                }
                ... on PageContentWidgetProjectsLinkNodesFileLink {
                  label
                  fileLink
                  styleInverse
                }
              }
              withBackgroundImage
              withBackgroundGradient
            }
            ... on PageContentWidgetContactForm {
              title
              content
              name
              sendButton
              resendButton
              successMessage
              errorMessage
            }
            ... on PageContentWidgetAnchor {
              name
            }
          }
          extract {
            __typename
            title
            summary
            imageNode {
              __typename
              image
              alt
              credits
            }
          }
          seo {
            __typename
            title
            description
            keywords
            image
          }
        }
        ... on Document {
          _sys {
            filename
            basename
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
      }
      anchor
      styleInverse
    }
    ... on MenuLinkNodesExternalLink {
      label
      url
      styleInverse
    }
    ... on MenuLinkNodesFileLink {
      label
      fileLink
      styleInverse
    }
  }
}
    `;
export const TagPartsFragmentDoc = gql`
    fragment TagParts on Tag {
  __typename
  tag
  color
  order
}
    `;
export const SettingsPartsFragmentDoc = gql`
    fragment SettingsParts on Settings {
  __typename
  ... on SettingsGeneralSettings {
    title
    websiteName
    websiteDescription
    websiteKeywords
    websiteLogo
    websiteIcon
    websiteTop
  }
  ... on SettingsSocialNetworkSettings {
    title
    websiteShareImage
    platforms {
      __typename
      name
      url
    }
  }
  ... on SettingsTrackingSettings {
    title
    googleAnalyticsId
  }
  ... on SettingsContactSettings {
    title
    contacts {
      __typename
      name
      linkNodes {
        __typename
        ... on SettingsContactSettingsContactsLinkNodesInternalLink {
          label
          internalLink {
            ... on Page {
              __typename
              type
              title
              path
              addedAt
              draft
              content {
                __typename
                ... on PageContentWidgetBannerImage {
                  image
                  alt
                  credits
                  aspectRatio
                }
                ... on PageContentWidgetHeading {
                  title
                  imageNode {
                    __typename
                    image
                    alt
                    credits
                  }
                  content
                  contentWithColumns
                  linkNodes {
                    __typename
                    ... on PageContentWidgetHeadingLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetHeadingLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetHeadingLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetImageGrid {
                  grid {
                    __typename
                    imageNodes {
                      __typename
                      image
                      alt
                      credits
                      aspectRatio
                    }
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetParagraphStack {
                  title
                  imageNode {
                    __typename
                    image
                    alt
                    credits
                    aspectRatio
                  }
                  specs {
                    __typename
                    title
                    content
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetParagraphGrid {
                  title
                  grid {
                    __typename
                    title
                    content
                    imageNode {
                      __typename
                      image
                      alt
                      credits
                    }
                  }
                  columns
                }
                ... on PageContentWidgetCards {
                  title
                  cards {
                    __typename
                    title
                    content
                    color
                    imageNode {
                      __typename
                      image
                      alt
                      credits
                    }
                  }
                  cardImageOnHover
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetBox {
                  title
                  content
                  linkNodes {
                    __typename
                    ... on PageContentWidgetBoxLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetBoxLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetBoxLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                }
                ... on PageContentWidgetCustomContent {
                  title
                  content
                  linkNodes {
                    __typename
                    ... on PageContentWidgetCustomContentLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetCustomContentLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetCustomContentLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                }
                ... on PageContentWidgetProjectHeading {
                  title
                  client
                  tags {
                    __typename
                  }
                  content
                  contentWithColumns
                  linkNodes {
                    __typename
                    ... on PageContentWidgetProjectHeadingLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetProjectHeadingLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetProjectHeadingLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetHomeHeading {
                  richTitle
                  richSubtitle
                }
                ... on PageContentWidgetSkills {
                  title
                  subtitle
                  skills {
                    __typename
                    name
                    description
                    imageNode {
                      __typename
                      image
                      alt
                      credits
                    }
                  }
                  linkNodes {
                    __typename
                    ... on PageContentWidgetSkillsLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetSkillsLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetSkillsLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetProjects {
                  title
                  subtitle
                  intro
                  limit
                  withFilter
                  linkNodes {
                    __typename
                    ... on PageContentWidgetProjectsLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetProjectsLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetProjectsLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetContactForm {
                  title
                  content
                  name
                  sendButton
                  resendButton
                  successMessage
                  errorMessage
                }
                ... on PageContentWidgetAnchor {
                  name
                }
              }
              extract {
                __typename
                title
                summary
                imageNode {
                  __typename
                  image
                  alt
                  credits
                }
              }
              seo {
                __typename
                title
                description
                keywords
                image
              }
            }
            ... on Document {
              _sys {
                filename
                basename
                breadcrumbs
                path
                relativePath
                extension
              }
              id
            }
          }
          anchor
          styleInverse
        }
        ... on SettingsContactSettingsContactsLinkNodesExternalLink {
          label
          url
          styleInverse
        }
        ... on SettingsContactSettingsContactsLinkNodesFileLink {
          label
          fileLink
          styleInverse
        }
      }
      imageNode {
        __typename
        image
        alt
        credits
      }
    }
  }
  ... on SettingsProjectSettings {
    title
    pagination {
      __typename
      title
      subtitle
      limit
      linkNodes {
        __typename
        ... on SettingsProjectSettingsPaginationLinkNodesInternalLink {
          label
          internalLink {
            ... on Page {
              __typename
              type
              title
              path
              addedAt
              draft
              content {
                __typename
                ... on PageContentWidgetBannerImage {
                  image
                  alt
                  credits
                  aspectRatio
                }
                ... on PageContentWidgetHeading {
                  title
                  imageNode {
                    __typename
                    image
                    alt
                    credits
                  }
                  content
                  contentWithColumns
                  linkNodes {
                    __typename
                    ... on PageContentWidgetHeadingLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetHeadingLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetHeadingLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetImageGrid {
                  grid {
                    __typename
                    imageNodes {
                      __typename
                      image
                      alt
                      credits
                      aspectRatio
                    }
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetParagraphStack {
                  title
                  imageNode {
                    __typename
                    image
                    alt
                    credits
                    aspectRatio
                  }
                  specs {
                    __typename
                    title
                    content
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetParagraphGrid {
                  title
                  grid {
                    __typename
                    title
                    content
                    imageNode {
                      __typename
                      image
                      alt
                      credits
                    }
                  }
                  columns
                }
                ... on PageContentWidgetCards {
                  title
                  cards {
                    __typename
                    title
                    content
                    color
                    imageNode {
                      __typename
                      image
                      alt
                      credits
                    }
                  }
                  cardImageOnHover
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetBox {
                  title
                  content
                  linkNodes {
                    __typename
                    ... on PageContentWidgetBoxLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetBoxLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetBoxLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                }
                ... on PageContentWidgetCustomContent {
                  title
                  content
                  linkNodes {
                    __typename
                    ... on PageContentWidgetCustomContentLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetCustomContentLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetCustomContentLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                }
                ... on PageContentWidgetProjectHeading {
                  title
                  client
                  tags {
                    __typename
                  }
                  content
                  contentWithColumns
                  linkNodes {
                    __typename
                    ... on PageContentWidgetProjectHeadingLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetProjectHeadingLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetProjectHeadingLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetHomeHeading {
                  richTitle
                  richSubtitle
                }
                ... on PageContentWidgetSkills {
                  title
                  subtitle
                  skills {
                    __typename
                    name
                    description
                    imageNode {
                      __typename
                      image
                      alt
                      credits
                    }
                  }
                  linkNodes {
                    __typename
                    ... on PageContentWidgetSkillsLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetSkillsLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetSkillsLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetProjects {
                  title
                  subtitle
                  intro
                  limit
                  withFilter
                  linkNodes {
                    __typename
                    ... on PageContentWidgetProjectsLinkNodesInternalLink {
                      label
                      anchor
                      styleInverse
                    }
                    ... on PageContentWidgetProjectsLinkNodesExternalLink {
                      label
                      url
                      styleInverse
                    }
                    ... on PageContentWidgetProjectsLinkNodesFileLink {
                      label
                      fileLink
                      styleInverse
                    }
                  }
                  withBackgroundImage
                  withBackgroundGradient
                }
                ... on PageContentWidgetContactForm {
                  title
                  content
                  name
                  sendButton
                  resendButton
                  successMessage
                  errorMessage
                }
                ... on PageContentWidgetAnchor {
                  name
                }
              }
              extract {
                __typename
                title
                summary
                imageNode {
                  __typename
                  image
                  alt
                  credits
                }
              }
              seo {
                __typename
                title
                description
                keywords
                image
              }
            }
            ... on Document {
              _sys {
                filename
                basename
                breadcrumbs
                path
                relativePath
                extension
              }
              id
            }
          }
          anchor
          styleInverse
        }
        ... on SettingsProjectSettingsPaginationLinkNodesExternalLink {
          label
          url
          styleInverse
        }
        ... on SettingsProjectSettingsPaginationLinkNodesFileLink {
          label
          fileLink
          styleInverse
        }
      }
    }
  }
}
    `;
export const PageDocument = gql`
    query page($relativePath: String!) {
  page(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...PageParts
  }
}
    ${PagePartsFragmentDoc}`;
export const PageConnectionDocument = gql`
    query pageConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: PageFilter) {
  pageConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...PageParts
      }
    }
  }
}
    ${PagePartsFragmentDoc}`;
export const MenuDocument = gql`
    query menu($relativePath: String!) {
  menu(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...MenuParts
  }
}
    ${MenuPartsFragmentDoc}`;
export const MenuConnectionDocument = gql`
    query menuConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: MenuFilter) {
  menuConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...MenuParts
      }
    }
  }
}
    ${MenuPartsFragmentDoc}`;
export const TagDocument = gql`
    query tag($relativePath: String!) {
  tag(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...TagParts
  }
}
    ${TagPartsFragmentDoc}`;
export const TagConnectionDocument = gql`
    query tagConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: TagFilter) {
  tagConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...TagParts
      }
    }
  }
}
    ${TagPartsFragmentDoc}`;
export const SettingsDocument = gql`
    query settings($relativePath: String!) {
  settings(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...SettingsParts
  }
}
    ${SettingsPartsFragmentDoc}`;
export const SettingsConnectionDocument = gql`
    query settingsConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: SettingsFilter) {
  settingsConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...SettingsParts
      }
    }
  }
}
    ${SettingsPartsFragmentDoc}`;
export type Requester<C= {}> = <R, V>(doc: DocumentNode, vars?: V, options?: C) => Promise<R>
  export function getSdk<C>(requester: Requester<C>) {
    return {
      page(variables: PageQueryVariables, options?: C): Promise<{data: PageQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: PageQueryVariables, query: string}> {
        return requester<{data: PageQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: PageQueryVariables, query: string}, PageQueryVariables>(PageDocument, variables, options);
      },
    pageConnection(variables?: PageConnectionQueryVariables, options?: C): Promise<{data: PageConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: PageConnectionQueryVariables, query: string}> {
        return requester<{data: PageConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: PageConnectionQueryVariables, query: string}, PageConnectionQueryVariables>(PageConnectionDocument, variables, options);
      },
    menu(variables: MenuQueryVariables, options?: C): Promise<{data: MenuQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: MenuQueryVariables, query: string}> {
        return requester<{data: MenuQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: MenuQueryVariables, query: string}, MenuQueryVariables>(MenuDocument, variables, options);
      },
    menuConnection(variables?: MenuConnectionQueryVariables, options?: C): Promise<{data: MenuConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: MenuConnectionQueryVariables, query: string}> {
        return requester<{data: MenuConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: MenuConnectionQueryVariables, query: string}, MenuConnectionQueryVariables>(MenuConnectionDocument, variables, options);
      },
    tag(variables: TagQueryVariables, options?: C): Promise<{data: TagQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: TagQueryVariables, query: string}> {
        return requester<{data: TagQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: TagQueryVariables, query: string}, TagQueryVariables>(TagDocument, variables, options);
      },
    tagConnection(variables?: TagConnectionQueryVariables, options?: C): Promise<{data: TagConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: TagConnectionQueryVariables, query: string}> {
        return requester<{data: TagConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: TagConnectionQueryVariables, query: string}, TagConnectionQueryVariables>(TagConnectionDocument, variables, options);
      },
    settings(variables: SettingsQueryVariables, options?: C): Promise<{data: SettingsQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: SettingsQueryVariables, query: string}> {
        return requester<{data: SettingsQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: SettingsQueryVariables, query: string}, SettingsQueryVariables>(SettingsDocument, variables, options);
      },
    settingsConnection(variables?: SettingsConnectionQueryVariables, options?: C): Promise<{data: SettingsConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: SettingsConnectionQueryVariables, query: string}> {
        return requester<{data: SettingsConnectionQuery, errors?: { message: string, locations: { line: number, column: number }[], path: string[] }[], variables: SettingsConnectionQueryVariables, query: string}, SettingsConnectionQueryVariables>(SettingsConnectionDocument, variables, options);
      }
    };
  }
  export type Sdk = ReturnType<typeof getSdk>;

// TinaSDK generated code
import { createClient, TinaClient } from "tinacms/dist/client";

const generateRequester = (
  client: TinaClient,
) => {
  const requester: (
    doc: any,
    vars?: any,
    options?: {
      branch?: string,
      /**
       * Aside from `method` and `body`, all fetch options are passed
       * through to underlying fetch request
       */
      fetchOptions?: Omit<Parameters<typeof fetch>[1], 'body' | 'method'>,
    },
    client
  ) => Promise<any> = async (doc, vars, options) => {
    let url = client.apiUrl
    if (options?.branch) {
      const index = client.apiUrl.lastIndexOf('/')
      url = client.apiUrl.substring(0, index + 1) + options.branch
    }
    const data = await client.request({
      query: doc,
      variables: vars,
      url,
    }, options)

    return { data: data?.data, errors: data?.errors, query: doc, variables: vars || {} }
  }

  return requester
}

/**
 * @experimental this class can be used but may change in the future
 **/
export const ExperimentalGetTinaClient = () =>
  getSdk(
    generateRequester(
      createClient({
        url: "https://content.tinajs.io/1.4/content/a7b3937c-bec2-4855-8cd3-1dbdea053396/github/main",
        queries,
      })
    )
  )

export const queries = (
  client: TinaClient,
) => {
  const requester = generateRequester(client)
  return getSdk(requester)
}

  